import { Component, OnInit, ViewChild, Input, ElementRef, HostListener, Signal, runInInjectionContext, effect, Injector, untracked, computed, AfterViewInit, OnDestroy, ChangeDetectorRef } from "@angular/core"; import { Location } from "@angular/common";
import { MenuItem } from 'primeng/api';
import { MessageService, ConfirmationService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Router, ActivatedRoute } from '@angular/router';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { ProfilService } from 'src/app/services/profil-service';
import { SelectionItemComponent, ETypeSelectionItem, ResultatSelectionItem } from 'src/app/controles/selection-item.component';
import { ContextMenu } from 'primeng/contextmenu/public_api';
import { EStatuts } from 'src/app/entites/enums/statuts';
import { ETypeBonTravail } from 'src/app/entites/enums/type-bon-travail';
import { RapportService } from 'src/app/services/rapport-service';
import { DatePipe } from '@angular/common';
import { AppMainComponent } from 'src/app/app.main.component';
import { Fournisseur } from 'src/app/entites/fournisseur';
import { FournisseurService } from 'src/app/services/fournisseur-service';
import { BaseComponent } from 'src/app/base/base-component';
import { BonTravailEntite } from 'src/app/entites/mecanique/bon-travail';
import { Emplacement } from 'src/app/entites/emplacement';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { ItemService } from 'src/app/services/item-service';
import { BonTravailService } from 'src/app/services/bon-travail-service';
import { RaisonBonTravailEntite } from 'src/app/entites/mecanique/raison-bon-travail';
import { environment } from 'src/environments/environment';
import { peutUtiliserWebShare } from 'src/app/services/web-share';
import { EtapeBonTravailEntite } from 'src/app/entites/mecanique/etape-bon-travail';
import { SaisieNoteMecaniqueComponent, ParametresSaisieNoteMecanique } from 'src/app/controles/mecanique/saisie-note-mecanique.component';
import { MessageInformationGuids } from 'src/app/entites/message-information.guids';
import { MessageInformationService } from 'src/app/services/message-information.service';
import { SelectionEtapesComponent, ResultatSelectionEtapes } from './controles/selection-etapes.component';
import { construireRequeteAjouterEtapes, etapesCreeesDepuisReponse, fusionnerEtapesAjoutees } from 'src/app/services/requetes/requete-ajouter-etapes-bon-travail';
import { marquerEtapeFaiteSiMecanicienChoisi } from './etape-fait-mecanicien';
import { actionGroupeeReussie, decocherSelectionTable } from './selection-table-bon-travail';
import { estChampDescriptionOuCategorieEtape, estEtapeEntretienPreventif } from './etape-ep-verrou';
import { PieceBonTravailEntite } from 'src/app/entites/mecanique/piece-bon-travail';
import { SelectionPieceComponent } from 'src/app/controles/mecanique/selection-piece.component';
import { EntretienPreventifEntite } from 'src/app/entites/mecanique/entretien-preventif';
import { HistoriqueEntretienComponent } from 'src/app/controles/mecanique/historique-entretien.component';
import { ItemMin } from 'src/app/entites/item-min';
import { AjustementInventaireComponent, ResultatAjustementInventaire } from 'src/app/controles/ajustement-inventaire.component';
import { ConsulterFournisseursComponent } from 'src/app/controles/consulter-fournisseurs.component';
import { PrixFournisseurEntite } from 'src/app/entites/prix-fournisseur';
import { SaisieQuantiteComponent } from 'src/app/controles/saisie-quantite.component';
import { NoteEntite } from 'src/app/entites/note';
import { GarantieEntite } from 'src/app/entites/garantie';
import { GarantieService } from 'src/app/services/garantie-service';
import { ETypeEtapeBonTravail } from 'src/app/entites/enums/type-etape-bon-travail';
import { EmployeEntite, enrichirRechercheEmploye } from 'src/app/entites/employe';
import { SeveriteEntite } from 'src/app/entites/mecanique/severite';
import { CategorieEntretienEntite } from 'src/app/entites/mecanique/categorie-entretien';
import { NoteService } from 'src/app/services/note-service';
import { DetailEntretienCorrectifComponent } from 'src/app/controles/mecanique/detail-entretien-correctif.component';
import { EntretienCorrectifEntite } from 'src/app/entites/mecanique/entretien-correctif';
import { SaisieNoteComponent } from 'src/app/controles/saisie-note.component';
import { ApprouverBonTravailComponent } from './controles/approuver-bon-travail.component';
import { HistoriquePosePieceComponent } from 'src/app/controles/mecanique/historique-pose-piece.component';
import { SelectionEmployesComponent } from 'src/app/controles/selection-employes.component';
import { SelectionEmployeComponent } from 'src/app/controles/selection-employe.component';
import { EnvoyerApprobationBonTravailComponent, RetourEnvoiApprobationBonTravail } from './controles/envoyer-approbation-bon-travail.component';
import { DocumentEntite } from "../../../entites/document";
import { DocumentService } from "../../../services/document-service";
import { ContexteService } from "../../../services/contexte-service";
import { OptionEtapeBonTravail } from "src/app/entites/mecanique/option-etape-bon-travail";
import { TableRowReorderEvent } from "primeng/table";
import { Table } from "primeng/table";
import { ETypeLien } from "src/app/entites/enums/type-lien-document";
import { RequeteApprobationSoumission } from "src/app/services/requetes/requete-approbation-soumission";
import { ComponentCanDeactivate } from "src/app/services/pending-changes.guard";
import { Observable, forkJoin } from "rxjs";
import { finalize } from "rxjs/operators";
import { ConfirmDialog } from "primeng/confirmdialog";
import { AjoutAnalyseBonTravailComponent } from "./controles/ajout-analyse-bon-travail.component";
import { AnalyseBonTravail } from "src/app/entites/analyse-bon-travail";
import { EntretienCorrectifService } from "src/app/services/entretien-correctif-service";
import { SignalWithWatcher } from "src/app/services/base.service";
import { extendedComputed } from 'ngxtension/computed';
import { WritableSignal, signal } from '@angular/core';
import { Toast } from 'primeng/toast';
import { ReleveHeureEntite } from 'src/app/entites/releve-heures';
import { ReleveKmEntite } from 'src/app/entites/releve-kms';

@Component({
    selector: 'app-detail-bdt',
    templateUrl: './detail-bon-travail.component.html',
    providers: [MessageService, DialogService],
    styleUrls: ['./detail-bon-travail.component.scss']
})
export class DetailBonTravailComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy, ComponentCanDeactivate {

    @Input('bdtId') inputBdcId: number;

    modeApercu: boolean = false;
    modeApprobation: boolean = false;

    commentaire: string;

    bonTravailId: number;
    bonTravail: WritableSignal<BonTravailEntite> = signal(null);
    bonTravailWatcher: SignalWithWatcher<BonTravailEntite>;
    selectionMultipleEtapes: EtapeBonTravailEntite[] = [];
    selectionMultiplePieces: PieceBonTravailEntite[] = [];
    /** Active bulk-action key on travail rows (drives button loading state). */
    actionGroupeeEtapesEnCours: 'marquerFait' | 'marquerNonFait' | 'mecanicien' | 'supprimer' | 'convertir' | null = null;
    actionGroupeePiecesEnCours = false;

    bonTravailTransferts: BonTravailEntite[] = [];
    selectionBonTravailTransfert: BonTravailEntite;

    afficherSidebarPieces: boolean = false;
    etapeCourantePourPieces: EtapeBonTravailEntite = null;

    etapeHighlightId: number | null = null;

    afficherHistorique = false;
    /** When reordering étapes by drag, maps étape key → preview # (1-based). */
    private etapeOrdrePreviewParCle = new Map<string, number>();
    private suivrePreviewReorderEtapes = false;
    private detacherPreviewReorderEtapes: (() => void) | null = null;
    etapeExpandueId: number | null = null;
    fieldPulseTokens: Record<string, number> = {};
    noteEnEdition = false;
    private lastOwnFieldPaths = new Set<string>();
    /** Ignores the next SignalR full-document refresh triggered by this client's own save. */
    private ignorerUpdatesHubBonTravail = 0;
    /** Active inline field/API saves; used to disable menubar actions briefly. */
    private sauvegardesEnCours = 0;
    /** When true, saving the étape note also adds it to the unit fiche (legacy dialog behaviour). */
    etapeAjouterNoteFiche: Record<number, boolean> = {};
    /** Unit-fiche note created from an étape, so later copies update instead of duplicating. */
    private etapeNoteFicheParEtape: Record<number, NoteEntite> = {};
    private etapeNoteFicheEnCours: Record<number, boolean> = {};

    afficherEmploye = (e: EmployeEntite) => e ? `${e.prenom} ${e.nom}` : '';
    afficherRaison = (r: RaisonBonTravailEntite) => r ? `${r.description} (${r.code})` : '';
    afficherNom = (x: { nom?: string }) => x?.nom ?? '';
    afficherSeverite = (s: SeveriteEntite) => s?.nom ?? '';
    afficherCategorieEntretien = (c: CategorieEntretienEntite) => c ? `${c.code} - ${c.description}` : '';
    afficherDate = (d: Date | string) => {
        if (!d) return '';
        const date = d instanceof Date ? d : new Date(d);
        return isNaN(date.getTime()) ? '' : date.toLocaleDateString('fr-CA');
    };
    afficherType = (t: number) => this.typesBonTravail?.find(x => x.value == t)?.label ?? '';
    texteNoteSimple = (html: string) => {
        if (!html) return '';
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        return (tmp.textContent || tmp.innerText || '').trim();
    };
    notes: NoteEntite[];
    garanties: GarantieEntite[] = [];
    chargementCompleteGaranties = false;

    typesBonTravail;

    emplacements: Emplacement[];
    fournisseurs: Fournisseur[];
    raisons: RaisonBonTravailEntite[];
    employes: EmployeEntite[];
    severites: SeveriteEntite[] = [];
    categoriesEntretien: CategorieEntretienEntite[] = [];
    tousEmployes: EmployeEntite[] = [];

    documents: DocumentEntite[];

    submitted = false;

    readonly noteQuillViewStyle: Record<string, string> = {
        'min-height': '100px',
        'max-height': '280px',
        'overflow-y': 'auto',
        'overflow-x': 'hidden',
        'border': '1px solid var(--surface-border)',
        'border-radius': '0.5rem',
        'width': '100%',
        'max-width': '100%',
        'box-sizing': 'border-box',
        'display': 'block',
    };

    readonly noteQuillEditorStyle: Record<string, string> = {
        'min-height': '120px',
        'width': '100%',
    };

    contenuMenuContextuelEtape: MenuItem[];
    contenuMenuContextuelPiece: MenuItem[];
    contenuMenuContextuelSuppr: MenuItem[];
    splitBtnItems: MenuItem[];

    auMoinsUnEtapeFait: Signal<boolean> = computed(() => {
        return this.bonTravail().etapes.filter(x => x.indComplete).length > 0
    });
    
    pieces: Signal<PieceBonTravailEntite[]> = computed(() => {
        if (!this.bonTravail()) {
            return [];
        }
        return this.bonTravail().etapes.flatMap(x => x.pieces).map(x => ({ ...x, noEtape: x?.noEtape }));
    });

    contenuMenuContextuelNote: MenuItem[];
    @ViewChild('menuContextuelNote') menuContextuelNote: ContextMenu;

    menu: MenuItem[];

    events: any[] = [
        { key: 'dateCreation', label: 'Date de création' },
        { key: 'dateTravail', label: 'Date de travail' },
        { key: 'dateFin', label: 'Date de fin' },
        { key: 'dateFermeture', label: 'Date de fermeture' },
    ];

    get estDocumentVerrouille(): boolean {
        const statutId = this.bonTravail()?.statut?.statutId;
        return statutId === EStatuts.Complete || statutId === EStatuts.Archive;
    }

    get peutModifierContenu(): boolean {
        return !this.modeApercu
            && !this.estDocumentVerrouille
            && (this.estAutorise('bontravail_modifier') || this.estAutorise('temp_mec'));
    }

    /** Menubar print/share/actions disabled only while an inline save is in flight. */
    get menubarActionsDesactivees(): boolean {
        return this.sauvegardesEnCours > 0;
    }

    @ViewChild('descriptionItem') champDescription: ElementRef;
    @ViewChild('menuContextuelEtape') menuContextuelEtape: ContextMenu;
    @ViewChild('menuContextuelPiece') menuContextuelPiece: ContextMenu;
    @ViewChild('menuContextuelSuppr') menuContextuelSuppr: ContextMenu;
    @ViewChild('dtTravail') dtTravail: Table;
    @ViewChild('dtPieces') dtPieces: Table;
    /** Ignore a deferred uncheck if the view was destroyed before the timeout. */
    private vueDetruite = false;
    constructor(
        sdb: DonneesBaseService,
        profilService: ProfilService,
        route: ActivatedRoute,
        appMain: AppMainComponent,
        private location: Location,
        private breadcrumbService: BreadcrumbService,
        private bonTravailService: BonTravailService,
        private entretienCorrectifService: EntretienCorrectifService,
        private ItemsService: ItemService,
        private documentService: DocumentService,
        private contexteService: ContexteService,
        private fournisseurService: FournisseurService,
        private rapportService: RapportService,
        private noteService: NoteService,
        private garantieService: GarantieService,
        private messageService: MessageService,
        public dialogService: DialogService,
        public routerService: Router,
        public datepipe: DatePipe,
        private injector: Injector,
        private messageInformationService: MessageInformationService,
        private cdr: ChangeDetectorRef) {

        super(sdb, profilService, route, routerService, appMain);

        this.breadcrumbService.setItems([
            { label: 'Bons de travail', routerLink: '/mecanique/bontravails' },
            { label: 'Détails' }
        ]);

        this.route.params.subscribe(params => this.bonTravailId = params.id);
    }

    ngOnInit() {

        this.splitBtnItems = [
            { label: 'Transformer sans approbation', icon: 'pi pi-send', command: () => this.transfererEnBonTravail() }
        ];

        if (this.inputBdcId) {
            this.bonTravailId = this.inputBdcId;
            this.modeApercu = true;

            console.log('Mode apercu');
            console.log(this.bonTravailId);
        }

        this.verifierAccesPageAuMoisUnAcces(['bonstravail', 'temp_mec']);

        var mode = this.route.snapshot.queryParamMap.get('mode');
        if (mode && mode == 'A') {
            this.modeApprobation = true;
        }
        this.Consulter();

        this.raisons = this.sdb.RaisonsBonTravail();

        this.employes = this.sdb.EmployesMecanique();
        this.employes.forEach(emp => enrichirRechercheEmploye(emp));
        this.tousEmployes = this.sdb.Employes();
        this.severites = this.sdb.Severites();
        this.categoriesEntretien = this.sdb.CategoriesEntretien();

        this.emplacements = this.sdb.Emplacements();

        this.typesBonTravail = [
            { value: ETypeBonTravail.Interne, label: "Interne" },
            { value: ETypeBonTravail.Externe, label: "Externe" }
        ];

        var p1 = new Promise<number>((resolve, reject) => {

            this.bonTravailService.ObtenirDetail(this.bonTravailId).subscribe(x => {
                this.bonTravail.set(x.value());
                this.bonTravailWatcher = x;

                runInInjectionContext(this.injector, () => {
                    effect(() => {
                        // Optional: Check if the signal has been initialized if needed
                        if (this.bonTravailWatcher && this.bonTravailWatcher.updates()) {
                            const update = this.bonTravailWatcher.updates(); // Read the signal once
                            console.log('Bon de travail update received:', update); // Keep for debuggin
                            if (update.type == 'update') {
                                if (this.ignorerUpdatesHubBonTravail > 0) {
                                    this.ignorerUpdatesHubBonTravail--;
                                    return;
                                }
                                if (this.sauvegardesEnCours > 0) {
                                    return;
                                }
                                this.messageService.add({ severity: 'info', summary: 'Bon de travail modifié', detail: "Ce bon de travail a été modifié par un utilisateur à l'instant" });
                                this.bonTravail.set({ ...this.bonTravailWatcher.updates().data, etapes: [...this.bonTravailWatcher.updates().data.etapes] });

                                this.initialiserBonTravail();
                            }
                        }
                    }, { allowSignalWrites: true });
                });

                Promise.all([
                    this.ItemsService.ObtenirNotesItem(this.bonTravail().item.itemId),
                    this.garantieService.ObtenirListeParItem(this.bonTravail().item.itemId)
                ]).then(([notesRes, garantiesRes]) => {
                    this.notes = notesRes.valeur;
                    this.garanties = garantiesRes.valeur ?? [];
                    this.chargementCompleteGaranties = true;
                    resolve(null);
                });
            });
        });

        var p3 = new Promise<number>((resolve, reject) => {
            this.fournisseurService.ObtenirFournisseurs().then(x => {
                this.fournisseurs = x.valeur;
                resolve(null);
            });
        });

        Promise.all([p1, p3]).then(x => {

            this.initialiserBonTravail();
            this.appliquerModeEdition();
            this.initialiserMenu();
            this.CompleterChargement(this.obtenirTitrePageBonTravail());
            this.ecouterFieldUpdates();

            if (!this.modeApercu) {
                this.messageInformationService.afficher(MessageInformationGuids.BtEditionInlineEnregistrementAuto);
            }
        });

        this.colonnesDisponibles = [
            { champ: 'ordre', entete: '#', afficheParDefaut: true },
            { champ: 'typeEtapeBonTravail.code', entete: 'Type', afficheParDefaut: true },
            { champ: 'categorie', entete: 'Catégorie', afficheParDefaut: true },
            { champ: 'description', entete: 'Description', afficheParDefaut: true },
            { champ: 'note', entete: 'Note', afficheParDefaut: true },
        ];

        this.colonnesSelectionnees = this.colonnesDisponibles.filter(x => x.afficheParDefaut);
    }

    @HostListener('window:beforeunload')
    public async canDeactivate(): Promise<boolean> {
        return true;
    }

    appliquerModeEdition(): void {
        if (this.peutModifierContenu) {
            this.Modifier();
        } else {
            this.Consulter();
        }
    }

    ouvrirHistorique(): void {
        this.afficherHistorique = true;
    }

    surHistoriqueRestaure(): void {
        this.bonTravailService.ObtenirDetail(this.bonTravailId).subscribe(x => {
            this.initialiserDonneesRetour(x.value());
            this.initialiserBonTravail();
            this.appliquerModeEdition();
            this.initialiserMenu();
            this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Version restaurée.' });
        });
    }

    /**
     * The API broadcasts a hub Update after each patch; skip refresh/notification for our own saves (one per HTTP edition call).
     */
    private marquerMutationLocaleBonTravail(nombre = 1): void {
        if (nombre > 0) {
            this.ignorerUpdatesHubBonTravail += nombre;
        }
    }

    private debutSauvegardeChamp(): void {
        this.sauvegardesEnCours++;
        if (this.sauvegardesEnCours === 1) {
            this.initialiserMenu();
        }
    }

    private terminerSauvegardeChamp(): void {
        this.sauvegardesEnCours = Math.max(0, this.sauvegardesEnCours - 1);
        if (this.sauvegardesEnCours === 0) {
            this.initialiserMenu();
        }
    }

    private avecIndicateurSauvegardeChamp<T>(source: Observable<T>, nombreUpdatesHubIgnorer = 1): Observable<T> {
        this.marquerMutationLocaleBonTravail(nombreUpdatesHubIgnorer);
        this.debutSauvegardeChamp();
        return source.pipe(finalize(() => this.terminerSauvegardeChamp()));
    }

    /**
     * Saves a header field immediately.
     */
    sauvegarderChamp(champ: string, valeur: any): void {
        if (!this.peutModifierContenu) {
            return;
        }
        this.lastOwnFieldPaths.add(`header.${champ.toLowerCase()}`);
        this.avecIndicateurSauvegardeChamp(this.bonTravailService.ModifierChamp(this.bonTravailId, champ, valeur)).subscribe({
            next: (res) => {
                if (res?.estUnSucces && res.valeur) {
                    this.appliquerRetourServeur(res.valeur);
                } else {
                    this.messageService.add({ severity: 'error', summary: 'Erreur', detail: res?.messages?.[0]?.description || 'Échec de la sauvegarde' });
                    this.rechargerDetail();
                }
            },
            error: () => {
                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Échec de la sauvegarde' });
                this.rechargerDetail();
            }
        });
    }

    /**
     * Persists a relevé compteur value (début or fin) via the inline field-save pipeline.
     */
    surSauvegardeReleveCompteur(
        valeur: number,
        champ: 'heuresdebutcompteur' | 'kmdebutcompteur' | 'heurescompteur' | 'kmcompteur',
        actuel?: number
    ): void {
        if (valeur === actuel) {
            return;
        }
        this.sauvegarderChamp(champ, valeur);
    }

    /**
     * Persists a pending relevé selection (or clears it) via the same field-save pipeline.
     */
    surLiaisonReleveChange(
        releve: ReleveHeureEntite | ReleveKmEntite | null,
        cote: 'debut' | 'fin',
        type: 'heure' | 'km'
    ): void {
        const champ = this.champLiaisonReleve(cote, type);
        const actuelId = this.identifiantReleveLie(cote, type);
        const nouveauId = type === 'heure'
            ? (releve as ReleveHeureEntite)?.releveHeureId
            : (releve as ReleveKmEntite)?.releveKmId;
        this.bonTravail.update(bt => {
            if (type === 'heure' && cote === 'debut') {
                return { ...bt, releveHeureDebut: (releve as ReleveHeureEntite) ?? undefined };
            }
            if (type === 'heure' && cote === 'fin') {
                return { ...bt, releveHeureFin: (releve as ReleveHeureEntite) ?? undefined };
            }
            if (type === 'km' && cote === 'debut') {
                return { ...bt, releveKmDebut: (releve as ReleveKmEntite) ?? undefined };
            }
            return { ...bt, releveKmFin: (releve as ReleveKmEntite) ?? undefined };
        });
        if (actuelId === nouveauId) {
            return;
        }
        this.sauvegarderChamp(champ, nouveauId ?? null);
    }

    /**
     * Nom du champ ModifierChamp correspondant à une liaison de relevé.
     */
    private champLiaisonReleve(cote: 'debut' | 'fin', type: 'heure' | 'km'): string {
        if (type === 'heure') {
            return cote === 'debut' ? 'releveheuredebutid' : 'releveheurefinid';
        }
        return cote === 'debut' ? 'revelekdebutid' : 'revelekfinid';
    }

    /**
     * Identifiant du relevé actuellement retenu pour une extrémité.
     */
    private identifiantReleveLie(cote: 'debut' | 'fin', type: 'heure' | 'km'): number | undefined {
        const bt = this.bonTravail();
        if (type === 'heure') {
            return cote === 'debut' ? bt?.releveHeureDebut?.releveHeureId : bt?.releveHeureFin?.releveHeureId;
        }
        return cote === 'debut' ? bt?.releveKmDebut?.releveKmId : bt?.releveKmFin?.releveKmId;
    }

    /**
     * Saves an étape field immediately. Description, note and categorie also update the linked EC.
     * Description and categorie are ignored on entretien préventif étapes (SIH-260).
     */
    sauvegarderEtapeChamp(etapeId: number, champ: string, valeur: any): void {
        if (!this.peutModifierContenu || !etapeId) {
            return;
        }
        const etape = this.bonTravail()?.etapes?.find(e => e.etapeBonTravailId === etapeId);
        if (etape && estEtapeEntretienPreventif(etape) && estChampDescriptionOuCategorieEtape(champ)) {
            return;
        }
        if (etape) {
            this.synchroniserChampsPartagesEtapeCorrectif(etape, champ, valeur);
            const nom = (champ ?? '').toLowerCase();
            if (nom === 'mecanicien' || nom === 'mecanicienid') {
                marquerEtapeFaiteSiMecanicienChoisi(etape, valeur);
            }
        }
        this.lastOwnFieldPaths.add(`etape.${etapeId}.${champ.toLowerCase()}`);
        this.avecIndicateurSauvegardeChamp(this.bonTravailService.ModifierEtapeChamp(etapeId, champ, valeur)).subscribe({
            next: (res) => {
                if (res?.estUnSucces && res.valeur) {
                    this.appliquerRetourServeur(res.valeur);
                } else {
                    this.messageService.add({ severity: 'error', summary: 'Erreur', detail: res?.messages?.[0]?.description || 'Échec de la sauvegarde' });
                    this.rechargerDetail();
                }
            },
            error: () => this.rechargerDetail()
        });
    }

    /**
     * Mirrors description, note and categorie onto the linked entretien correctif (same field).
     */
    private synchroniserChampsPartagesEtapeCorrectif(etape: EtapeBonTravailEntite, champ: string, valeur: any): void {
        const nom = (champ ?? '').toLowerCase();
        if (nom === 'description' && typeof valeur === 'string') {
            etape.description = valeur;
            if (etape.entretienCorrectif) {
                etape.entretienCorrectif.description = valeur;
            }
        } else if (nom === 'note' && typeof valeur === 'string') {
            etape.note = valeur;
            if (etape.entretienCorrectif) {
                etape.entretienCorrectif.note = valeur;
            }
        } else if ((nom === 'categorie' || nom === 'categorieentretienid') && valeur) {
            etape.categorie = valeur;
            if (etape.entretienCorrectif) {
                etape.entretienCorrectif.categorie = valeur;
            }
        }
    }

    /**
     * Whether an étape carries a linked entretien correctif editable inline.
     */
    estEtapeEC(etape: EtapeBonTravailEntite): boolean {
        return !!etape?.entretienCorrectif
            && etape?.typeEtapeBonTravail?.typeEtapeBonTravailId === ETypeEtapeBonTravail.EntretienCorrectif;
    }

    /**
     * Whether the étape is an entretien préventif (linked EP or type EP).
     */
    estEtapeEP(etape: EtapeBonTravailEntite): boolean {
        return estEtapeEntretienPreventif(etape);
    }

    /**
     * Whether Description and Catégorie may be edited inline on this étape.
     */
    peutModifierDescriptionCategorieEtape(etape: EtapeBonTravailEntite): boolean {
        return this.peutModifierContenu && !estEtapeEntretienPreventif(etape);
    }

    /**
     * Saves a correctif-only field (sévérité, pièce en commande) from the étape panel.
     */
    sauvegarderCorrectifChamp(etape: EtapeBonTravailEntite, champ: string, valeur: any): void {
        if (!this.peutModifierContenu || !etape?.etapeBonTravailId || !etape?.entretienCorrectif) {
            return;
        }
        const correctif = etape.entretienCorrectif;
        if (champ === 'correctifSeverite' && valeur) {
            correctif.severite = valeur;
        } else if (champ === 'correctifIndPieceEnCommande') {
            correctif.indPieceEnCommande = !!valeur;
        }
        this.sauvegarderEtapeChamp(etape.etapeBonTravailId, champ, valeur);
    }

    /** Whether soumission options should be persisted to the API. */
    private peutEnregistrerOptionsSoumission(etape: EtapeBonTravailEntite): boolean {
        return this.peutModifierContenu
            && this.bonTravail().indSoumission
            && !!etape?.indAFaire;
    }

    /** Persists option field edits (upsert) and refreshes totals. */
    surChangementOptionSoumission(etape: EtapeBonTravailEntite, option: OptionEtapeBonTravail): void {
        this.CalculTotal();
        if (!this.peutEnregistrerOptionsSoumission(etape) || !option) {
            return;
        }
        if (this.optionSoumissionEstVide(option) && !option.optionEtapeBonTravailId) {
            return;
        }
        this.sauvegarderOptionEtape(etape, option);
    }

    /** Persists the retained soumission option on an étape (server id). */
    surSelectionOptionSoumission(etape: EtapeBonTravailEntite, optionId: number | null): void {
        this.CalculTotal();
        if (!this.peutEnregistrerOptionsSoumission(etape) || optionId == null) {
            return;
        }
        const option = etape.optionEtapeBonTravails?.find(o =>
            optionId > 0
                ? o.optionEtapeBonTravailId === optionId
                : !o.optionEtapeBonTravailId
        );
        if (!option) {
            return;
        }
        if (!option.optionEtapeBonTravailId) {
            if (this.optionSoumissionEstVide(option)) {
                return;
            }
            this.sauvegarderOptionEtape(etape, option, () => {
                const refreshed = this.bonTravail().etapes
                    .find(e => e.etapeBonTravailId === etape.etapeBonTravailId)
                    ?.optionEtapeBonTravails?.find(o => o.optionEtapeBonTravailId === option.optionEtapeBonTravailId)
                    ?? this.bonTravail().etapes
                        .find(e => e.etapeBonTravailId === etape.etapeBonTravailId)
                        ?.optionEtapeBonTravails?.find(o =>
                            o.optionEtapeBonTravailId > 0
                            && o.description === option.description
                            && o.montantPieces === option.montantPieces
                            && o.nbHeures === option.nbHeures
                        );
                if (refreshed?.optionEtapeBonTravailId) {
                    etape.optionEtapeBonTravailId = refreshed.optionEtapeBonTravailId;
                    this.sauvegarderEtapeChamp(etape.etapeBonTravailId, 'optionEtapeBonTravailId', refreshed.optionEtapeBonTravailId);
                }
            });
            return;
        }
        etape.optionEtapeBonTravailId = option.optionEtapeBonTravailId;
        this.sauvegarderEtapeChamp(etape.etapeBonTravailId, 'optionEtapeBonTravailId', option.optionEtapeBonTravailId);
    }

    /** Deletes a soumission option on the server when it was previously saved. */
    surSuppressionOptionSoumission(etape: EtapeBonTravailEntite, option: OptionEtapeBonTravail): void {
        this.CalculTotal();
        if (!this.peutEnregistrerOptionsSoumission(etape) || !option) {
            return;
        }
        if (!option.optionEtapeBonTravailId) {
            return;
        }
        this.avecIndicateurSauvegardeChamp(this.bonTravailService.SupprimerOption(option.optionEtapeBonTravailId)).subscribe({
            next: (res) => {
                if (res?.estUnSucces && res.valeur) {
                    this.appliquerRetourServeur(res.valeur);
                    this.CalculTotal();
                } else {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erreur',
                        detail: res?.messages?.[0]?.description || 'Impossible de supprimer l\'option'
                    });
                    this.rechargerDetail();
                }
            },
            error: () => this.rechargerDetail()
        });
    }

    private optionSoumissionEstVide(option: OptionEtapeBonTravail): boolean {
        return (
            !option.description?.trim()
            && (option.montantPieces == null || option.montantPieces === undefined)
            && (option.nbHeures == null || option.nbHeures === undefined)
        );
    }

    private sauvegarderOptionEtape(etape: EtapeBonTravailEntite, option: OptionEtapeBonTravail, apresSucces?: () => void): void {
        if (!etape?.etapeBonTravailId) {
            return;
        }
        this.lastOwnFieldPaths.add(`etape.${etape.etapeBonTravailId}.option`);
        this.avecIndicateurSauvegardeChamp(this.bonTravailService.UpsertOption(etape.etapeBonTravailId, {
            optionEtapeBonTravailId: option.optionEtapeBonTravailId > 0 ? option.optionEtapeBonTravailId : null,
            description: option.description ?? '',
            nbHeures: option.nbHeures ?? null,
            montantPieces: option.montantPieces ?? null
        })).subscribe({
            next: (res) => {
                if (res?.estUnSucces && res.valeur) {
                    this.fusionnerBonTravailApresOptionUpsert(etape, option, res.valeur);
                    this.CalculTotal();
                    apresSucces?.();
                } else {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erreur',
                        detail: res?.messages?.[0]?.description || 'Impossible d\'enregistrer l\'option'
                    });
                    this.rechargerDetail();
                }
            },
            error: () => this.rechargerDetail()
        });
    }

    /** Merges server option data without rebuilding the options table (keeps focus). */
    private fusionnerBonTravailApresOptionUpsert(
        etape: EtapeBonTravailEntite,
        localOption: OptionEtapeBonTravail,
        serverBon: BonTravailEntite
    ): void {
        const serverEtape = serverBon.etapes?.find(e => e.etapeBonTravailId === etape.etapeBonTravailId);
        if (!serverEtape) {
            return;
        }

        const knownServerIds = new Set(
            (etape.optionEtapeBonTravails ?? [])
                .filter(o => o !== localOption && o.optionEtapeBonTravailId > 0)
                .map(o => o.optionEtapeBonTravailId)
        );

        let serverOption = localOption.optionEtapeBonTravailId > 0
            ? serverEtape.optionEtapeBonTravails?.find(o => o.optionEtapeBonTravailId === localOption.optionEtapeBonTravailId)
            : serverEtape.optionEtapeBonTravails?.find(o => !knownServerIds.has(o.optionEtapeBonTravailId));

        untracked(() => {
            const bt = this.bonTravail();
            const e = bt?.etapes?.find(x => x.etapeBonTravailId === etape.etapeBonTravailId);
            const o = e?.optionEtapeBonTravails?.find(x => x === localOption)
                ?? e?.optionEtapeBonTravails?.find(x =>
                    localOption.optionEtapeBonTravailId > 0
                        ? x.optionEtapeBonTravailId === localOption.optionEtapeBonTravailId
                        : !x.optionEtapeBonTravailId && x.description === localOption.description
                );
            if (o && serverOption) {
                o.optionEtapeBonTravailId = serverOption.optionEtapeBonTravailId;
                o.description = serverOption.description;
                o.montantPieces = serverOption.montantPieces;
                o.nbHeures = serverOption.nbHeures;
                localOption.optionEtapeBonTravailId = serverOption.optionEtapeBonTravailId;
            }
        });

        this.bonTravail.update(bt => ({
            ...bt,
            coutReelPieces: serverBon.coutReelPieces,
            coutReelHeures: serverBon.coutReelHeures
        }));
    }

    basculerExpansionEtape(etape: EtapeBonTravailEntite, event?: Event): void {
        if (event) {
            const target = event.target as HTMLElement;
            if (target.closest(
                '.p-checkbox, .p-datatable-reorderablerow-handle, .p-tablecheckbox, .etape-ordre-controls, .p-inputswitch, button, a, input, textarea, .p-dropdown, .p-selectbutton, app-inline-editable-field'
            )) {
                return;
            }
        }
        if (this.etapeExpandueId === etape.etapeBonTravailId) {
            this.etapeExpandueId = null;
            return;
        }
        if (this.bonTravail().indSoumission) {
            this.preparerOptionsEtapeSoumission(etape);
        }
        this.etapeExpandueId = etape.etapeBonTravailId;
        this.defilerVersEtape(etape);
    }

    /** Étapes currently visible in the travaux table (respects global filter). */
    private obtenirEtapesVisiblesTableau(): EtapeBonTravailEntite[] {
        const filtered = this.dtTravail?.filteredValue as EtapeBonTravailEntite[] | null | undefined;
        if (filtered != null) {
            return filtered;
        }
        return this.bonTravail().etapes ?? [];
    }

    /** Whether prev/next navigation is available for the expanded row. */
    peutNaviguerEtapeExpandue(direction: -1 | 1, etapeId: number): boolean {
        const etapes = this.obtenirEtapesVisiblesTableau();
        const idx = etapes.findIndex(e => e.etapeBonTravailId === etapeId);
        if (idx < 0) {
            return false;
        }
        const nextIdx = idx + direction;
        return nextIdx >= 0 && nextIdx < etapes.length;
    }

    /** Moves expanded detail to the previous or next visible étape. */
    naviguerEtapeExpandue(direction: -1 | 1, etapeId: number): void {
        const etapes = this.obtenirEtapesVisiblesTableau();
        const idx = etapes.findIndex(e => e.etapeBonTravailId === etapeId);
        if (idx < 0) {
            return;
        }
        const nextIdx = idx + direction;
        if (nextIdx < 0 || nextIdx >= etapes.length) {
            return;
        }
        const next = etapes[nextIdx];
        if (this.bonTravail().indSoumission) {
            this.preparerOptionsEtapeSoumission(next);
        }
        this.etapeExpandueId = next.etapeBonTravailId;
        this.defilerVersEtape(next);
    }

    private defilerVersEtape(etape: EtapeBonTravailEntite): void {
        this.mettreEtapeTravauxEnEvidence(etape, { expand: false, focus: false });
    }

    /**
     * Scrolls to an étape in the travaux table, optionally expanding the row and moving keyboard focus.
     */
    private mettreEtapeTravauxEnEvidence(
        etape: EtapeBonTravailEntite,
        options: { expand?: boolean; focus?: boolean; block?: ScrollLogicalPosition } = {}
    ): void {
        if (!etape?.noEtape) {
            return;
        }
        if (options.expand) {
            if (this.bonTravail().indSoumission) {
                this.preparerOptionsEtapeSoumission(etape);
            }
            this.etapeExpandueId = etape.etapeBonTravailId;
        }
        const block = options.block ?? 'nearest';
        const apply = () => {
            const el = document.getElementById(`etape-${etape.noEtape}`) as HTMLElement | null;
            if (!el) {
                return false;
            }
            el.scrollIntoView({ behavior: 'smooth', block });
            if (options.focus) {
                el.focus({ preventScroll: true });
            }
            if (etape.etapeBonTravailId) {
                this.etapeHighlightId = etape.etapeBonTravailId;
                setTimeout(() => {
                    this.etapeHighlightId = null;
                }, 2000);
            }
            return true;
        };
        setTimeout(() => apply(), 0);
        setTimeout(() => apply(), 120);
    }

    /** Focuses the last newly added étape after a reload (or the last row if none identified). */
    private ciblerEtapesApresAjout(idsAvant: Set<number>): void {
        const etapes = [...(this.bonTravail().etapes ?? [])].sort((a, b) => (a.ordre ?? 0) - (b.ordre ?? 0));
        if (!etapes.length) {
            return;
        }
        const nouvelles = etapes.filter(e => e.etapeBonTravailId && !idsAvant.has(e.etapeBonTravailId));
        const cible = nouvelles.length ? nouvelles[nouvelles.length - 1] : etapes[etapes.length - 1];
        this.mettreEtapeTravauxEnEvidence(cible, { expand: true, focus: true, block: 'nearest' });
    }

    private cibleIgnoreNavigationClavier(event: KeyboardEvent): boolean {
        const target = event.target as HTMLElement | null;
        if (!target) {
            return false;
        }
        if (target.isContentEditable) {
            return true;
        }
        const tag = target.tagName;
        if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') {
            return true;
        }
        return !!target.closest('.ql-editor, .p-dropdown-panel, .p-multiselect-panel, .p-select-overlay, .p-autocomplete-panel');
    }

    @HostListener('document:keydown', ['$event'])
    surNavigationClavierEtapeExpandue(event: KeyboardEvent): void {
        if (this.etapeExpandueId == null || this.cibleIgnoreNavigationClavier(event)) {
            return;
        }
        if (event.key === 'ArrowUp' && this.peutNaviguerEtapeExpandue(-1, this.etapeExpandueId)) {
            event.preventDefault();
            this.naviguerEtapeExpandue(-1, this.etapeExpandueId);
        } else if (event.key === 'ArrowDown' && this.peutNaviguerEtapeExpandue(1, this.etapeExpandueId)) {
            event.preventDefault();
            this.naviguerEtapeExpandue(1, this.etapeExpandueId);
        }
    }

    /** Ensures soumission étapes have an options array before the editor is shown. */
    preparerOptionsEtapeSoumission(etape: EtapeBonTravailEntite): void {
        if (!etape) {
            return;
        }
        etape.optionEtapeBonTravails = etape.optionEtapeBonTravails ?? [];
    }

    /** True when the collapsed row should list at least one saved variant (not only an empty draft row). */
    etapeAfficheOptionsCompactes(etape: EtapeBonTravailEntite): boolean {
        const opts = etape?.optionEtapeBonTravails;
        if (!opts?.length) {
            return false;
        }
        return opts.some(o =>
            !!(o.description?.trim()) ||
            (o.montantPieces != null && o.montantPieces !== 0) ||
            (o.nbHeures != null && o.nbHeures !== 0)
        );
    }

    private appliquerRetourServeur(valeur: BonTravailEntite): void {
        const etapeOuverteId = this.etapeExpandueId;
        const draftsOuverts = etapeOuverteId != null
            ? (this.bonTravail()?.etapes?.find(e => e.etapeBonTravailId === etapeOuverteId)
                ?.optionEtapeBonTravails ?? []).filter(o => !o.optionEtapeBonTravailId)
            : [];

        this.initialiserDonneesRetour(valeur);

        if (etapeOuverteId != null && draftsOuverts.length) {
            this.bonTravail.update(bt => ({
                ...bt,
                etapes: bt.etapes.map(e => {
                    if (e.etapeBonTravailId !== etapeOuverteId) {
                        return e;
                    }
                    return {
                        ...e,
                        optionEtapeBonTravails: [...(e.optionEtapeBonTravails ?? []), ...draftsOuverts]
                    };
                })
            }));
        }

        this.initialiserBonTravail();
        this.appliquerModeEdition();
    }

    private rechargerDetail(apresChargement?: () => void): void {
        this.bonTravailService.ObtenirDetail(this.bonTravailId).subscribe(x => {
            this.appliquerRetourServeur(x.value());
            this.initialiserMenu();
            if (apresChargement) {
                setTimeout(() => apresChargement(), 0);
            }
        });
    }

    private ecouterFieldUpdates(): void {
        const connection = this.bonTravailService['hubConnection'] as import('@microsoft/signalr').HubConnection;
        if (!connection) {
            return;
        }
        connection.off('bontravails:FieldUpdate');
        connection.on('bontravails:FieldUpdate', (update: { bonTravailId: number; path: string; employeId?: number }) => {
            if (update?.bonTravailId !== this.bonTravailId) {
                return;
            }
            const pathKey = update.path?.toLowerCase?.() ?? update.path;
            const employeCourantId = this.profilService.ProfilCourant()?.employeId;
            if (update.employeId != null && employeCourantId != null && update.employeId === employeCourantId) {
                if (this.lastOwnFieldPaths.has(pathKey)) {
                    this.lastOwnFieldPaths.delete(pathKey);
                }
                return;
            }
            if (this.lastOwnFieldPaths.has(pathKey)) {
                this.lastOwnFieldPaths.delete(pathKey);
                return;
            }
            this.fieldPulseTokens = {
                ...this.fieldPulseTokens,
                [update.path]: (this.fieldPulseTokens[update.path] || 0) + 1
            };
        });
    }

    chargerDocuments() {
        this.documentService.ObtenirListeDocuments(ETypeLien.BonTravail, untracked(this.bonTravail).bonTravailId).subscribe({
            next: (res) => {
                res.body.documents.forEach(doc => {
                    doc.apercu = 'data:image/jpeg;base64,' + doc.apercu;
                });

                this.documents = res.body.documents;
            },
            error: (err) => {
                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Une erreur est survenue lors du chargement des documents' });
            }
        });

    }

    initialiserMenu() {

        //TODO: Compléter accès
        this.estModifiable = this.bonTravail().statut.statutId != EStatuts.Complete;

        if (this.bonTravail().indSoumission) {
            this.menu = [
                {
                    label: 'Retour', icon: 'pi pi-fw pi-angle-double-left', command: () => window.history.back()
                },
                {
                    label: 'Historique', icon: 'pi pi-fw pi-history',
                    command: () => this.ouvrirHistorique()
                },
                {
                    label: 'Imprimer', icon: 'pi pi-fw pi-print',
                    disabled: this.menubarActionsDesactivees,
                    items: [
                        {
                            label: '1 page', icon: 'pi pi-fw pi-print',
                            command: () => this.imprimer(true)
                        },
                        {
                            label: 'Page Vierge', icon: 'pi pi-fw pi-print',
                            command: () => this.imprimerVierge()
                        },
                    ]
                },
                {
                    label: 'Envoyer', icon: 'pi pi-fw pi-send',
                    visible: this.estAutorise('temp_mec') || this.estAutorise('bontravail_envoyer_courriel'),
                    disabled: this.menubarActionsDesactivees,
                    command: () => this.envoyer(true)
                },
                {
                    label: 'Voir le bon de travail', icon: 'pi pi-fw pi-eye',
                    visible: this.bonTravail().bonTravailLie != null,
                    command: () => this.routerService.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                        this.routerService.navigate(['mecanique/bontravails/' + this.bonTravail().bonTravailLie.bonTravailId]);
                    })
                },
                {
                    label: 'Actions', icon: 'pi pi-fw pi-bars',
                    disabled: this.menubarActionsDesactivees,
                    items: [
                        {
                            label: 'Transférer en bon de travail', icon: 'pi pi-fw pi-arrow-right',
                            disabled: !this.estAutorise('temp_mec') || !this.estAutorise('bontravail_approuver'),
                            visible: this.bonTravail().statut.statutId != EStatuts.Complete,
                            command: () => this.OuvrirPopupApprobation()
                        },
                        { separator: this.bonTravail().statut.statutId != EStatuts.Complete, },
                        {
                            label: 'Supprimer la soumission', icon: 'pi pi-fw pi-times',
                            styleClass: 'menuSuppression',
                            command: () => this.supprimerbonTravail()
                        }
                    ]
                }
            ];
        } else {
            this.menu = [
                {
                    label: 'Retour', icon: 'pi pi-fw pi-angle-double-left', command: () => window.history.back()
                },
                {
                    label: 'Historique', icon: 'pi pi-fw pi-history',
                    command: () => this.ouvrirHistorique()
                },
                {
                    label: 'Imprimer', icon: 'pi pi-fw pi-print',
                    disabled: this.menubarActionsDesactivees,
                    items: [
                        {
                            label: '1 page', icon: 'pi pi-fw pi-print',
                            command: () => this.imprimer(false)
                        },
                        {
                            label: '2 pages', icon: 'pi pi-fw pi-print',
                            command: () => this.imprimer(true)
                        },
                        {
                            label: 'Page Vierge', icon: 'pi pi-fw pi-print',
                            command: () => this.imprimerVierge()
                        },
                    ]
                },
                {
                    label: 'Envoyer', icon: 'pi pi-fw pi-send',
                    visible: this.estAutorise('temp_mec') || this.estAutorise('bontravail_envoyer_courriel'),
                    disabled: this.menubarActionsDesactivees,
                    items: [
                        {
                            label: '1 page', icon: 'pi pi-fw pi-print',
                            command: () => this.envoyer(false)
                        },
                        {
                            label: '2 pages', icon: 'pi pi-fw pi-print',
                            command: () => this.envoyer(true)
                        },
                    ]
                },
                {
                    label: 'Partager', icon: 'pi pi-fw pi-share-alt',
                    visible: peutUtiliserWebShare(),
                    disabled: this.menubarActionsDesactivees,
                    items: [
                        {
                            label: 'Lien', icon: 'pi pi-fw pi-link',
                            command: () => this.partager()
                        },
                        {
                            label: 'PDF', icon: 'pi pi-fw pi-file-pdf',
                            command: () => this.partagerPdf()
                        },

                    ]
                },
                {
                    label: 'Voir la soumission', icon: 'pi pi-fw pi-eye',
                    visible: this.bonTravail().bonTravailLie != null,
                    command: () => this.routerService.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                        this.routerService.navigate(['mecanique/bontravails/' + this.bonTravail().bonTravailLie.bonTravailId]);
                    })
                },
                {
                    label: 'Voir l\'analyse', icon: 'pi pi-fw pi-eye',
                    visible: this.bonTravail().analyseBonTravail != null,
                    command: () => this.routerService.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                        this.routerService.navigate(['mecanique/bontravails/analyse/' + this.bonTravail().analyseBonTravail.analyseBonTravailId]);
                    })
                },
                {
                    label: 'Actions', icon: 'pi pi-fw pi-bars',
                    disabled: this.menubarActionsDesactivees,
                    items: [
                        {
                            label: 'Envoyer en approbation', icon: 'pi pi-fw pi-forward',
                            visible: (this.estAutorise('bontravail_envoyer_approb') || this.estAutorise('temp_mec')) && this.bonTravail().statut.statutId != EStatuts.Complete && this.bonTravail().statut.statutId != EStatuts.EnApprobation, //TODO
                            disabled: !this.auMoinsUnEtapeFait(),
                            command: _ => this.envoyerApprobation()
                        },
                        {
                            label: 'Approuver le bon de travail', icon: 'pi pi-fw pi-forward',
                            visible: (this.estAutorise('bontravail_approuver') || this.estAutorise('temp_mec')) && this.bonTravail().statut.statutId != EStatuts.Complete, //TODO
                            disabled: !this.auMoinsUnEtapeFait(),
                            command: _ => this.approuver()
                        },
                        {
                            label: 'Créer une analyse', icon: 'pi pi-fw pi-plus',
                            visible: (this.estAutorise('bontravail_approuver') || this.estAutorise('temp_mec')) && this.bonTravail().statut.statutId == EStatuts.Complete && this.bonTravail().analyseBonTravail == null, //TODO 
                            command: _ => this.creerAnalyse()
                        },
                        { separator: true },
                        {
                            label: 'Supprimer le bon de travail', icon: 'pi pi-fw pi-times',
                            styleClass: 'menuSuppression',
                            visible: (this.estAutorise('bontravail_supprimer') || this.estAutorise('temp_mec')) && this.bonTravail().statut.statutId != EStatuts.Complete,
                            //TODO
                            disabled: this.bonTravail().statut.statutId == EStatuts.Complete,
                            command: () => this.supprimerbonTravail()
                        }
                    ]
                },
            ];
        }
    }

    obtenirTitrePageBonTravail(): string {
        const type = this.bonTravail().indSoumission ? 'Soumission' : 'Bon de travail';
        return `${type} ${this.bonTravail().numero} (${this.bonTravail().item.numero})`;
    }

    /** Tooltip for the modifiable / non-modifiable marker in the menu bar. */
    obtenirTooltipStatutEdition(): string {
        if (this.peutModifierContenu) {
            const libelle = this.bonTravail()?.indSoumission ? 'Cette soumission' : 'Ce bon de travail';
            return [
                `${libelle} est modifiable.`,
                'Cliquez sur un champ pour le modifier ; la valeur est enregistrée automatiquement lorsque vous quittez le champ.',
                'Cliquez sur une ligne de travail pour ouvrir le détail (note, options, pièces, etc.).',
                'Aucun bouton « Enregistrer » n\'est nécessaire pour ces modifications.'
            ].join('\n\n');
        }
        if (this.estDocumentVerrouille) {
            return 'Document verrouillé (complété ou archivé). Les champs sont en lecture seule.';
        }
        if (this.modeApercu) {
            return 'Mode aperçu : ouvrez la fiche complète pour modifier le document.';
        }
        return 'Vous n\'avez pas les droits pour modifier ce document.';
    }

    nombreColonnesTableauTravail(): number {
        let count = (this.colonnesSelectionnees?.length ?? 0) + 2;

        if (!this.modeConsultation()) {
            count += 2;
        }
        if (this.bonTravail().indSoumission) {
            count += 1;
        } else {
            count += 1;
        }

        return count;
    }

    /** Nombre d'étapes marquées complètes sur le bon de travail. */
    obtenirNombreEtapesCompletes(): number {
        return this.bonTravail().etapes?.filter(e => e.indComplete).length ?? 0;
    }

    /** Nombre total d'étapes sur le bon de travail. */
    obtenirNombreEtapesTotal(): number {
        return this.bonTravail().etapes?.length ?? 0;
    }

    /** Pourcentage d'avancement des travaux (0–100). */
    obtenirPourcentageAvancementTravaux(): number {
        const total = this.obtenirNombreEtapesTotal();
        if (total === 0) {
            return 0;
        }
        return Math.round((this.obtenirNombreEtapesCompletes() / total) * 100);
    }

    /** Durée entre la date de travail et la date de fin (libellé en français). */
    obtenirDureeTravaux(): string | null {
        const debut = this.convertirEnDateBonTravail(this.bonTravail()?.dateTravail);
        const fin = this.convertirEnDateBonTravail(this.bonTravail()?.dateFin);
        if (!debut || !fin || fin.getTime() < debut.getTime()) {
            return null;
        }
        return this.formaterDureeTravaux(debut, fin);
    }

    private convertirEnDateBonTravail(valeur: Date | string | null | undefined): Date | null {
        if (valeur == null) {
            return null;
        }
        const date = valeur instanceof Date ? valeur : new Date(valeur);
        return Number.isNaN(date.getTime()) ? null : date;
    }

    private debutDeJournee(date: Date): Date {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    }

    private dateAHeureSignificative(date: Date): boolean {
        return date.getHours() !== 0 || date.getMinutes() !== 0 || date.getSeconds() !== 0 || date.getMilliseconds() !== 0;
    }

    private formaterDureeTravaux(debut: Date, fin: Date): string {
        const debutJour = this.debutDeJournee(debut);
        const finJour = this.debutDeJournee(fin);
        const ecartJoursCalendrier = Math.round((finJour.getTime() - debutJour.getTime()) / 86_400_000);

        if (ecartJoursCalendrier === 0) {
            if (this.dateAHeureSignificative(debut) || this.dateAHeureSignificative(fin)) {
                return this.formaterDureeHeuresMinutes(fin.getTime() - debut.getTime());
            }
            return '1 jour';
        }

        const joursInclusifs = ecartJoursCalendrier + 1;
        return joursInclusifs === 1 ? '1 jour' : `${joursInclusifs} jours`;
    }

    private formaterDureeHeuresMinutes(dureeMs: number): string {
        const totalMinutes = Math.max(0, Math.floor(dureeMs / 60_000));
        const heures = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        const parties: string[] = [];

        if (heures > 0) {
            parties.push(heures === 1 ? '1 heure' : `${heures} heures`);
        }
        if (minutes > 0) {
            parties.push(minutes === 1 ? '1 minute' : `${minutes} minutes`);
        }
        if (parties.length === 0) {
            return '1 jour';
        }
        return parties.join(' et ');
    }

    initialiserBonTravail() {
        if (untracked(this.bonTravail)) {

            this.bonTravail.update(x => {

                if (x.mecanicien) {
                    x.mecanicien = this.employes.find(y => y.employeId == x.mecanicien.employeId);
                }
                if (x.contreMaitre) {
                    x.contreMaitre = this.employes.find(y => y.employeId == x.contreMaitre.employeId);
                }
                if (x.raison) {
                    x.raison = this.raisons.find(y => y.raisonBonTravailId == x.raison.raisonBonTravailId);
                }
                if (x.fournisseur) {
                    x.fournisseur = this.fournisseurs.find(y => y.fournisseurId == x.fournisseur.fournisseurId);
                }
                if (x.emplacement) {
                    x.emplacement = this.emplacements.find(y => y.emplacementId == x.emplacement.emplacementId);
                }

                return x;
            });

            if (untracked(this.bonTravail).etapes) {
                this.bonTravail.update(x => {
                    const etapes = x.etapes.map(et => {
                        if (et.mecanicien) {
                            et.mecanicien = this.employes.find(y => y.employeId == et.mecanicien.employeId);
                        }
                        if (et.categorie) {
                            et.categorie = this.categoriesEntretien.find(y => y.categorieEntretienId == et.categorie.categorieEntretienId) ?? et.categorie;
                        }
                        if (et.entretienCorrectif) {
                            const ec = et.entretienCorrectif;
                            if (ec.categorie) {
                                ec.categorie = this.categoriesEntretien.find(y => y.categorieEntretienId == ec.categorie.categorieEntretienId) ?? ec.categorie;
                            }
                            if (ec.severite) {
                                ec.severite = this.severites.find(y => y.severiteId == ec.severite.severiteId) ?? ec.severite;
                            }
                            if (ec.employe) {
                                ec.employe = this.tousEmployes.find(y => y.employeId == ec.employe.employeId) ?? ec.employe;
                            }
                        }
                        et.optionEtapeBonTravails = et.optionEtapeBonTravails ?? [];
                        return et;
                    });

                    return { ...x, etapes: etapes };
                });
            }

            this.chargerDocuments();
            this.initialiserNoEtapes();
            this.CalculTotal();
        }
    }

    ngAfterViewInit() {
        this.chargerColonnesSelectionnees();
        setTimeout(() => this.installerPreviewReorderEtapes(), 0);
    }

    ngOnDestroy(): void {
        this.vueDetruite = true;
        this.detacherPreviewReorderEtapes?.();
        this.detacherPreviewReorderEtapes = null;
        this.arreterPreviewReorderEtapes();
    }

    /** Stable key for preview ordre map (server id). */
    private cleEtapePourOrdre(etape: EtapeBonTravailEntite): string {
        return `id:${etape?.etapeBonTravailId ?? 0}`;
    }

    /** # column value; live preview while dragging to reorder. */
    obtenirOrdreAfficheEtape(etape: EtapeBonTravailEntite): number {
        const preview = this.etapeOrdrePreviewParCle.get(this.cleEtapePourOrdre(etape));
        return preview ?? etape?.ordre ?? etape?.noEtape ?? 0;
    }

    ordreEtapeChangeEnPreview(etape: EtapeBonTravailEntite): boolean {
        if (!this.etapeOrdrePreviewParCle.size) {
            return false;
        }
        const preview = this.etapeOrdrePreviewParCle.get(this.cleEtapePourOrdre(etape));
        return preview != null && preview !== etape?.ordre;
    }

    private convertirIndiceDeposeReorder(draggedRowIndex: number, droppedRowIndex: number): number {
        return draggedRowIndex > droppedRowIndex
            ? droppedRowIndex
            : droppedRowIndex === 0 ? 0 : droppedRowIndex - 1;
    }

    private mapsOrdrePreviewEgaux(a: Map<string, number>, b: Map<string, number>): boolean {
        if (a.size !== b.size) {
            return false;
        }
        for (const [k, v] of a) {
            if (b.get(k) !== v) {
                return false;
            }
        }
        return true;
    }

    private appliquerPreviewOrdreEtapes(dragIndex: number, dropIndex: number): void {
        const etapes = this.bonTravail().etapes ?? [];
        if (!etapes.length || dragIndex < 0 || dragIndex >= etapes.length) {
            return;
        }
        const indices = Array.from({ length: etapes.length }, (_, i) => i);
        const [removed] = indices.splice(dragIndex, 1);
        indices.splice(dropIndex, 0, removed);
        const next = new Map<string, number>();
        indices.forEach((originalIndex, position) => {
            next.set(this.cleEtapePourOrdre(etapes[originalIndex]), position + 1);
        });
        if (this.mapsOrdrePreviewEgaux(next, this.etapeOrdrePreviewParCle)) {
            return;
        }
        this.etapeOrdrePreviewParCle = next;
        this.cdr.markForCheck();
    }

    private boucleActualisationPreviewReorderEtapes(): void {
        if (!this.suivrePreviewReorderEtapes) {
            return;
        }
        const dt = this.dtTravail;
        if (dt?.rowDragging && dt.draggedRowIndex != null && dt.droppedRowIndex != null) {
            const dropIndex = this.convertirIndiceDeposeReorder(dt.draggedRowIndex, dt.droppedRowIndex);
            this.appliquerPreviewOrdreEtapes(dt.draggedRowIndex, dropIndex);
        }
        requestAnimationFrame(() => this.boucleActualisationPreviewReorderEtapes());
    }

    private arreterPreviewReorderEtapes(): void {
        this.suivrePreviewReorderEtapes = false;
        if (this.etapeOrdrePreviewParCle.size === 0) {
            return;
        }
        this.etapeOrdrePreviewParCle = new Map();
        this.cdr.markForCheck();
    }

    private readonly onDragStartPreviewEtape = (event: DragEvent) => {
        const target = event.target as HTMLElement | null;
        if (!target?.closest?.('.p-datatable-reorderablerow-handle')) {
            return;
        }
        this.suivrePreviewReorderEtapes = true;
        this.boucleActualisationPreviewReorderEtapes();
    };

    private readonly onDragEndPreviewEtape = () => {
        this.arreterPreviewReorderEtapes();
    };

    private installerPreviewReorderEtapes(): void {
        if (this.detacherPreviewReorderEtapes || !this.dtTravail?.el?.nativeElement) {
            return;
        }
        const host = this.dtTravail.el.nativeElement as HTMLElement;
        host.addEventListener('dragstart', this.onDragStartPreviewEtape, true);
        host.addEventListener('dragend', this.onDragEndPreviewEtape, true);
        this.detacherPreviewReorderEtapes = () => {
            host.removeEventListener('dragstart', this.onDragStartPreviewEtape, true);
            host.removeEventListener('dragend', this.onDragEndPreviewEtape, true);
        };
    }

    /**
     * Applies a full server BT payload into local state (header fields + étapes).
     * Must overwrite editable champs so inline fields can clear their saving spinner.
     */
    initialiserDonneesRetour(bonTravail: BonTravailEntite) {
        this.bonTravail.update(x => {
            return {
                ...x,
                ...bonTravail,
                statut: bonTravail.statut?.statutId != null
                    ? this.sdb.Statut(bonTravail.statut.statutId)
                    : x.statut,
                dateAssignation: bonTravail.dateAssignation ? new Date(bonTravail.dateAssignation) : null,
                dateTravail: bonTravail.dateTravail ? new Date(bonTravail.dateTravail) : null,
                dateFin: bonTravail.dateFin ? new Date(bonTravail.dateFin) : null,
                dateFermeture: bonTravail.dateFermeture ? new Date(bonTravail.dateFermeture) : null,
                etapes: bonTravail.etapes ?? x.etapes,
            };
        });
    }

    CalculTotal() {
        if (untracked(this.bonTravail)) {
            untracked(this.bonTravail).coutReelHeures = 0;
            untracked(this.bonTravail).coutReelPieces = 0;

            if (untracked(this.bonTravail).indSoumission) {
                untracked(this.bonTravail).etapes.forEach(et => {
                    if (et.indAFaire) {
                        var option = et.optionEtapeBonTravails?.find(x => x.optionEtapeBonTravailId == et.optionEtapeBonTravailId);

                        if (option) {
                            untracked(this.bonTravail).coutReelHeures += option.nbHeures ? option.nbHeures : 0;
                            untracked(this.bonTravail).coutReelPieces += option.montantPieces ? option.montantPieces : 0;
                        }
                    }
                });
            }
        }
    }

    initialiserNoEtapes() {

        untracked(this.bonTravail).etapes.forEach((et, index) => {

            et.noEtape = index + 1;
            et.ordre = et.noEtape;
            et.pieces = et.pieces?.map(p => {
                return {
                    ...p,
                    noEtape: et.noEtape
                };
            });
        });

    }

    partager() {
        navigator.share({
            title: 'SIHC - Bon de travail',
            text: 'Bon de travail #' + this.bonTravail().numero,
            url: environment.urlBase + '/mecanique/bontravail/' + this.bonTravail().bonTravailId
        });
    }

    partagerPdf() {
        this.rapportService.ObtenirPdfBonTravail(this.bonTravail().bonTravailId, this.bonTravail().indSoumission, false).then(x => {
            if (x) {
                navigator.share({
                    title: 'SIHC - Bon de travail',
                    text: 'Bon de travail #' + this.bonTravail().numero,
                    files: [new File([x], 'bon_travail-' + this.bonTravail().numero + '.pdf', { type: 'application/pdf' })]
                });
            }
        }).catch(x => {
            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Impossible de partager le bon de travail au format PDF.' });
        });
    }

    surChangementSelectionEtape() {
    }

    ouvrirFicheComplete() {
        this.routerService.navigateByUrl('mecanique/bontravails/' + this.bonTravailId);
        this.appMain.afficherDetailBonTravail = false;
    }

    /// <summary>
    /// Scrolls to the etape with the given number and highlights it for 1 second
    /// </summary>
    scrollToEtape(noEtape: number) {
        const etape = this.bonTravail().etapes.find(e => e.noEtape === noEtape);
        if (etape) {
            this.mettreEtapeTravauxEnEvidence(etape, { expand: false, focus: true, block: 'center' });
        }
    }

    imprimer(multiPages: boolean) {
        this.messageService.add({ severity: 'info', summary: 'Demande de rapport', detail: `Votre demande de rapport a été envoyée.` });

        this.rapportService.ProduireRapportBonTravail(this.bonTravail().bonTravailId, multiPages, this.bonTravail().indSoumission).then(x => {
            if (x) {
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: `Votre rapport a été généré.` });
            } else {
                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: `Une erreur est survenue pendant la génération de votre rapport.` });
            }
        });
    }

    imprimerVierge() {
        this.messageService.add({ severity: 'info', summary: 'Demande de rapport', detail: `Votre demande de rapport a été envoyée.` });
        this.rapportService.ProduireRapportBonTravail(this.bonTravail().bonTravailId, false, this.bonTravail().indSoumission, true).then(x => {
            if (x) {
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: `Votre rapport a été généré.` });
            } else {
                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: `Une erreur est survenue pendant la génération de votre rapport.` });
            }
        });
    }

    imprimerSoumission() {
        this.messageService.add({ severity: 'info', summary: 'Demande de rapport', detail: `Votre demande de rapport a été envoyée.` });
    }

    Approbation() {
        const ref = this.dialogService.open(SelectionEmployesComponent, {
            data: {
                employesIds: []
            },
            header: 'Envoi du bon de travail',
            width: '60%'
        }).onClose.subscribe((res: EmployeEntite[]) => {
            if (res) {

                this.Bloquer();

                var requete: RequeteApprobationSoumission = {
                    commentaire: this.commentaire,
                    destinataires: res.map(x => x.courriel)
                };

                this.bonTravailService.EnvoyerApprobationSoumission(this.bonTravail().bonTravailId, requete).subscribe({
                    next: (res) => {
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: "Soumission envoyée en approbation" });
                        this.bonTravail().statut = this.sdb.Statut(EStatuts.EnApprobation);
                        this.Debloquer();
                        this.appMain.confirmationService.close();
                    },
                    error: (err) => {
                        this.bonTravailService.errorHandler(err, "Bon de travail");
                        this.Debloquer();
                    }
                });
            }
        });
    }

    OuvrirPopupApprobation() {
        if (this.modeApprobation) {
            this.transfererEnBonTravail();
            return;
        }

        this.appMain.confirmationService.confirm({
            target: event.target,
            key: 'transformer-soumission-bon-travail',
            message: 'Voulez-vous envoyer cette soumission en approbation ?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
        });
    }

    creerAnalyse() {
        this.dialogService.open(AjoutAnalyseBonTravailComponent, {
            data: {
                bonTravail: this.bonTravail()
            },
            header: 'Créer une analyse',
            width: '50%',
        }).onClose.subscribe((res: AnalyseBonTravail) => {
            if (res) {
                this.routerService.navigateByUrl('mecanique/bontravails/analyse/' + res.analyseBonTravailId);
            }
        });
    }

    surChangementTypeBonTravail() {
        // TODO
    }

    surChangementOrdreEtape(event: TableRowReorderEvent) {
        this.arreterPreviewReorderEtapes();
        if (event.dragIndex > event.dropIndex) {
            this.bonTravail().etapes.find(x => x.ordre == event.dragIndex + 1).ordre = event.dropIndex + 1;
            Array.from(
                { length: event.dragIndex - event.dropIndex },
                (_, i) => event.dropIndex + i
            ).forEach(x => {
                this.bonTravail().etapes[x].ordre = x + 2;
            });
        } else {
            this.bonTravail().etapes.find(x => x.ordre == event.dragIndex + 1).ordre = event.dropIndex + 1;
            Array.from(
                { length: event.dropIndex - event.dragIndex },
                (_, i) => event.dragIndex + i + 1
            ).forEach(x => {
                this.bonTravail().etapes[x].ordre = x;
            });
        }
        this.bonTravail().etapes.sort((a, b) => a.ordre - b.ordre);
        this.initialiserNoEtapes();
        this.dtTravail.sortSingle();
        if (this.peutModifierContenu) {
            const orderedIds = this.bonTravail().etapes.map(e => e.etapeBonTravailId).filter(id => !!id);
            this.avecIndicateurSauvegardeChamp(this.bonTravailService.ReordonnerEtapes(this.bonTravailId, orderedIds)).subscribe({
                next: (res) => {
                    if (res?.estUnSucces && res.valeur) {
                        this.appliquerRetourServeur(res.valeur);
                    }
                },
                error: () => this.rechargerDetail()
            });
        }
    }

    supprimerbonTravail() {
        this.appMain.confirmationService.confirm({
            target: event.target,
            key: 'basic',
            message: 'Voulez-vous vraiment supprimer le bon de travail courant ?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.bonTravailService.Supprimer(this.bonTravail().bonTravailId).then(res => {
                    if (res.estUnSucces) {
                        this.routerService.navigateByUrl('mecanique/bontravails');
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Bon de travail supprimé.' });
                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                });

            }
        });
    }

    envoyerApprobation() {

        const ref = this.dialogService.open(EnvoyerApprobationBonTravailComponent, {
            data: {
                bonTravail: this.bonTravail()
            },
            header: 'Envoyer le bon de travail en approbation',
            width: '50%'
        }).onClose.subscribe((res: RetourEnvoiApprobationBonTravail) => {

            if (res) {

                this.bonTravail().heuresMecanicien = res.nbHeures;
                this.bonTravail().kmMecanicien = res.nbKm;
                this.bonTravail().dateFin = new Date(res.dateFin);
                this.bonTravail().releveHeureFin = res.releveHeureFin;
                this.bonTravail().releveKmFin = res.releveKmFin;

                this.bonTravailService.EnvoyerApprobation(this.bonTravail()).then(res => {
                    if (res.estUnSucces) {
                        this.initialiserDonneesRetour(res.valeur);
                        this.initialiserMenu();
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Bon de travail envoyé en approbation.' });
                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                });
            }
        });

    }

    approuver() {

        const ref = this.dialogService.open(ApprouverBonTravailComponent, {
            data: {
                bonTravail: this.bonTravail(),
                alerteEtapesNonCompletes: this.bonTravail().etapes.filter(x => !x.indComplete).length > 0
            },
            header: 'Approuver le bon de travail',
            width: '50%',
        }).onClose.subscribe((res: BonTravailEntite) => {

            if (res) {
                this.initialiserDonneesRetour(res);
                this.initialiserMenu();
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Bon de travail complété.' });
            }
        });
    }

    transfererEnBonTravail() {
        this.Bloquer();
        this.bonTravailService.TransformerSoumission(this.bonTravail()).then(res => {
            if (res.estUnSucces) {
                this.Debloquer();
                this.routerService.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                    this.routerService.navigate(['mecanique/bontravails/' + res.valeur.bonTravailLie.bonTravailId]);
                });
            } else {
                res.messages.forEach(x => {
                    this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                });
                this.Debloquer();
            }
        });
    }



    /* ------------   ÉTAPES   ----------- */

    surMenuContextuelEtape(event, etape: EtapeBonTravailEntite) {

        this.contenuMenuContextuelEtape = [
            {
                label: etape.indAFaire ? 'Enlever à faire' : 'Mettre à faire', icon: 'pi pi-fw pi-check',
                visible: this.estAutorise('temp_mec') && !this.modeConsultation() && !this.bonTravail().indSoumission,
                command: _ => { etape.indAFaire = !etape.indAFaire; }
            },
            {
                label: 'Voir l\'entretien', icon: 'pi pi-fw pi-eye',
                visible: this.modeConsultation() && this.estAutorise('temp_mec') && etape.typeEtapeBonTravail.typeEtapeBonTravailId == ETypeEtapeBonTravail.EntretienPreventif,
                command: _ => this.routerService.navigateByUrl('mecanique/entretienpreventif/' + etape.entretienPreventif.entretienPreventifId)
            },
            {
                label: 'Voir l\'historique', icon: 'pi pi-fw pi-calendar',
                visible: this.estAutorise('temp_mec') && etape.typeEtapeBonTravail.typeEtapeBonTravailId == ETypeEtapeBonTravail.EntretienPreventif,
                command: _ => this.consulterHistoriqueEntretienPreventif(this.bonTravail().item, etape.entretienPreventif)
            },
            {
                label: 'Annuler l\'entretien préventif', icon: 'pi pi-fw pi-times',
                visible: this.modeConsultation() && this.estAutorise('temp_mec') && etape.typeEtapeBonTravail.typeEtapeBonTravailId == ETypeEtapeBonTravail.EntretienPreventif && this.bonTravail().statut.statutId == EStatuts.Complete && etape.indComplete,
                command: _ => this.annulerEntretienPreventifComplete(etape)
            },
            {
                label: 'Modifier l\'entretien correctif', icon: 'pi pi-fw pi-pencil',
                visible: this.estAutorise('temp_mec') && etape.typeEtapeBonTravail.typeEtapeBonTravailId == ETypeEtapeBonTravail.EntretienCorrectif,
                command: _ => this.modifierEntretienCorrectif(etape, etape.entretienCorrectif)
            },
            {
                label: 'Voir les pièces', icon: 'pi pi-fw pi-box',
                visible: etape.pieces && etape.pieces.length > 0,
                command: _ => this.afficherSidebarPiecesEtape(etape)
            },
            // { separator: true },
            // {
            //     label: 'Ajouter une note', icon: 'pi pi-fw pi-pencil',
            //     visible: this.estAutorise('temp_mec') && !this.modeApercu,
            //     disabled: this.bonTravail.statut.statutId == EStatuts.Complete,
            //     command: () => this.ajouterNoteEtape(etape)
            // },
            // { separator: true },
            // {
            //     label: 'Supprimer', icon: 'pi pi-fw pi-times',
            //     visible: this.estAutorise('temp_mec') && !this.modeApercu,
            //     disabled: this.bonTravail.statut.statutId == EStatuts.Complete,
            //     command: () => this.supprimerEtapes(event, [etape])
            // }
        ];


        this.menuContextuelEtape.toggle(event);
    }

    supprimerEtapes(event, itemsBonsTravail: EtapeBonTravailEntite[]) {

        if (itemsBonsTravail.length == 1 && itemsBonsTravail[0].entretienCorrectif) {
            this.contenuMenuContextuelSuppr = [
                { label: 'Supprimer du bon de travail', icon: 'pi pi-fw pi-times', command: _ => this.supprimerEtapeEntretienCorrectif(itemsBonsTravail[0]) },
                { label: 'Supprimer l\'entretien correctif', icon: 'pi pi-fw pi-times', command: _ => this.supprimerEntretienCorrectif(itemsBonsTravail[0]) }
            ];
            this.menuContextuelSuppr.toggle(event);
            return;
        }

        var ids = itemsBonsTravail.map(b => b.etapeBonTravailId).filter(id => !!id);

        this.appMain.confirmationService.confirm({
            target: event.target,
            key: 'basic',
            message: itemsBonsTravail.length == 1 ? 'Voulez-vous vraiment supprimer l\'étape sélectionnée ?' : 'Voulez-vous vraiment supprimer les étapes sélectionnées ?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.actionGroupeeEtapesEnCours = 'supprimer';
                this.avecIndicateurSauvegardeChamp(this.bonTravailService.SupprimerEtapes(this.bonTravailId, ids)).pipe(
                    finalize(() => { this.actionGroupeeEtapesEnCours = null; })
                ).subscribe({
                    next: (res) => {
                        if (actionGroupeeReussie([res])) {
                            this.appliquerRetourServeur(res.valeur);
                            this.decocherEtapesApresSucces();
                            this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Étape(s) supprimée(s).' });
                        } else {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: res?.messages?.[0]?.description || 'Échec' });
                        }
                    },
                    error: () => this.rechargerDetail()
                });
            }
        });
    }

    /**
     * Removes an entretien-correctif étape from the BT via the edition API.
     */
    supprimerEtapeEntretienCorrectif(etape: EtapeBonTravailEntite) {
        if (!etape?.etapeBonTravailId) {
            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Impossible de supprimer une étape non enregistrée.' });
            return;
        }
        this.avecIndicateurSauvegardeChamp(this.bonTravailService.SupprimerEtapes(this.bonTravailId, [etape.etapeBonTravailId])).subscribe({
            next: (res) => {
                if (actionGroupeeReussie([res])) {
                    this.appliquerRetourServeur(res.valeur);
                    this.decocherEtapesApresSucces();
                    this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Étape supprimée.' });
                } else {
                    this.messageService.add({ severity: 'error', summary: 'Erreur', detail: res?.messages?.[0]?.description || 'Échec' });
                }
            },
            error: () => this.rechargerDetail()
        });
    }

    supprimerEntretienCorrectif(etape: EtapeBonTravailEntite) {
        this.appMain.confirmationService.confirm({
            target: event.target,
            key: 'basic',
            message: 'Voulez-vous vraiment supprimer l\'entretien correctif sélectionné ? Cette action est irréversible.',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                if (!etape?.etapeBonTravailId) {
                    this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Impossible de supprimer une étape non enregistrée.' });
                    return;
                }
                this.Bloquer();
                this.entretienCorrectifService.Supprimer(etape.entretienCorrectif.entretienCorrectifId).then(res => {
                    if (!res?.estUnSucces) {
                        this.Debloquer();
                        (res?.messages || []).forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                        return;
                    }
                    this.avecIndicateurSauvegardeChamp(this.bonTravailService.SupprimerEtapes(this.bonTravailId, [etape.etapeBonTravailId])).subscribe({
                        next: (r) => {
                            this.Debloquer();
                            if (actionGroupeeReussie([r])) {
                                this.appliquerRetourServeur(r.valeur);
                                this.decocherEtapesApresSucces();
                                this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Entretien correctif supprimé.' });
                            } else {
                                this.rechargerDetail();
                            }
                        },
                        error: () => {
                            this.Debloquer();
                            this.rechargerDetail();
                        }
                    });
                }).catch(() => {
                    this.Debloquer();
                    this.rechargerDetail();
                });
            }
        });
    }

    /**
     * Converts selected entretien-correctif étapes to manual via the API.
     */
    convertirEtapesVersAut(event, itemsBonsTravail: EtapeBonTravailEntite[]) {
        if (itemsBonsTravail.some(x => !x.etapeBonTravailId)) {
            this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: 'Impossible de convertir une étape non enregistrée.'
            });
            return;
        }

        const shouldProcess = !!itemsBonsTravail.every(x => x.typeEtapeBonTravail.typeEtapeBonTravailId === ETypeEtapeBonTravail.EntretienCorrectif);
        if (!shouldProcess) {
            this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: 'Certaines étapes sélectionnées ne sont pas des EC. Seuls les EC peuvent être convertis en manuel.'
            });
            return;
        }

        const ids = itemsBonsTravail.map(b => b.etapeBonTravailId);
        this.appMain.confirmationService.confirm({
            target: event.target,
            key: 'basic',
            message: itemsBonsTravail.length == 1
                ? 'Voulez-vous vraiment convertir l\'étape sélectionnée en entretien manuel ?'
                : 'Voulez-vous vraiment convertir les étapes sélectionnées en entretiens manuels ?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.actionGroupeeEtapesEnCours = 'convertir';
                this.Bloquer();
                Promise.all(ids.map(id => this.bonTravailService.ConvertirEtapeBonTravailToManuel(id)))
                    .then(results => {
                        this.Debloquer();
                        if (!actionGroupeeReussie(results)) {
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Erreur',
                                detail: 'Une erreur est survenue lors de la conversion de certaines étapes.'
                            });
                            this.rechargerDetail();
                            return;
                        }
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Succès',
                            detail: 'Étape(s) convertie(s) en manuel.'
                        });
                        this.decocherEtapesApresSucces();
                        this.rechargerDetail(() => this.decocherEtapesApresSucces());
                    })
                    .catch(() => {
                        this.Debloquer();
                        this.rechargerDetail();
                    })
                    .finally(() => {
                        this.actionGroupeeEtapesEnCours = null;
                    });
            }
        });
    }

    obtenirOptionSelectionnee(etape: EtapeBonTravailEntite) {
        return etape.optionEtapeBonTravails?.find(o => o.optionEtapeBonTravailId == etape.optionEtapeBonTravailId);
    }

    modifierEtapeBonTravail(itemBonTravail: EtapeBonTravailEntite) {

        /* const ref = this.dialogService.open(ModificationItemBonTravailComponent, {
            data: {
                itemBonTravail: itemBonTravail
            },
            header: 'Modifier un item',
            width: '90%'
        }).onClose.subscribe((res: ItemBonTravail) => {
            console.log(res);
            if (res) {
                itemBonTravail.quantite = res.quantite;
                itemBonTravail.noFournisseur = res.noFournisseur;
                itemBonTravail.prix = res.prix;
                itemBonTravail.codeProjet = res.codeProjet;
                itemBonTravail.codeActivite = res.codeActivite;
                itemBonTravail.codeCategorie = res.codeCategorie;
                itemBonTravail.note = res.note;
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: `Item modifié.` });
            }

        }); */

    }

    modifierNote(event, etape: EtapeBonTravailEntite) {
        const ref = this.dialogService.open(SaisieNoteMecaniqueComponent, {
            data: {
                note: etape.note ? etape.note : '',
                afficherAjoutFiche: true,
                indAjouterFiche: false
            },
            header: 'Ajouter une note',
            width: '80%'
        }).onClose.subscribe((res: ParametresSaisieNoteMecanique) => {
            if (res) {
                this.sauvegarderNoteEtape(etape, res.note, res.indAjouterFiche);
            }
        });
    }

    /**
     * Copies the current étape note to the unit fiche when the switch is turned on,
     * even if the note was already saved.
     */
    onEtapeAjouterNoteFicheChange(active: boolean, etape: EtapeBonTravailEntite): void {
        if (!active) {
            return;
        }
        this.messageInformationService.afficher(MessageInformationGuids.BtAjouterNoteFiche);
        this.copierNoteEtapeVersFiche(etape);
    }

    /**
     * Saves an étape note and optionally copies it to the unit fiche.
     */
    sauvegarderNoteEtape(etape: EtapeBonTravailEntite, note: string, ajouterALaFiche?: boolean): void {
        if (!etape?.etapeBonTravailId) {
            return;
        }

        const valeur = note != null ? String(note) : '';
        this.sauvegarderEtapeChamp(etape.etapeBonTravailId, 'note', valeur);

        const copierSurFiche = ajouterALaFiche ?? this.etapeAjouterNoteFiche[etape.etapeBonTravailId] ?? false;
        if (!copierSurFiche) {
            return;
        }
        this.copierNoteEtapeVersFiche(etape, valeur);
    }

    /**
     * Creates or updates the unit-fiche note from the étape note.
     */
    private copierNoteEtapeVersFiche(etape: EtapeBonTravailEntite, note?: string): void {
        if (!etape?.etapeBonTravailId || !this.peutModifierContenu) {
            return;
        }
        const valeur = (note != null ? String(note) : (etape.note ?? '')).trim();
        if (!valeur) {
            return;
        }
        if (this.etapeNoteFicheEnCours[etape.etapeBonTravailId]) {
            return;
        }

        const existante = this.etapeNoteFicheParEtape[etape.etapeBonTravailId];
        this.etapeNoteFicheEnCours[etape.etapeBonTravailId] = true;
        this.Bloquer();

        const apres = (succes: boolean, detail: string, messages?: { description: string }[]) => {
            this.etapeNoteFicheEnCours[etape.etapeBonTravailId] = false;
            this.Debloquer();
            if (succes) {
                this.rechargerNotesUnite();
                this.messageService.add({ severity: 'success', summary: 'Succès', detail });
            } else {
                messages?.forEach(x => {
                    this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                });
            }
        };

        if (existante?.noteId) {
            const ancienne = existante.description;
            existante.description = valeur;
            this.noteService.Modifier(existante).then(res => {
                if (res?.estUnSucces) {
                    apres(true, 'Note mise à jour sur la fiche de l\'unité.');
                } else {
                    existante.description = ancienne;
                    apres(false, '', res?.messages);
                }
            }).catch(() => {
                existante.description = ancienne;
                this.etapeNoteFicheEnCours[etape.etapeBonTravailId] = false;
                this.Debloquer();
            });
            return;
        }

        this.noteService.Ajouter({
            date: new Date(),
            employe: this.profilService.ProfilCourant(),
            item: this.bonTravail().item,
            description: valeur
        }).then(resAjoutNote => {
            if (resAjoutNote?.estUnSucces) {
                this.etapeNoteFicheParEtape[etape.etapeBonTravailId] = resAjoutNote.valeur ?? { description: valeur };
                apres(true, 'Note ajoutée à la fiche de l\'unité.');
            } else {
                apres(false, '', resAjoutNote?.messages);
            }
        }).catch(() => {
            this.etapeNoteFicheEnCours[etape.etapeBonTravailId] = false;
            this.Debloquer();
        });
    }

    annulerEntretienPreventifComplete(etape: EtapeBonTravailEntite) {
        this.appMain.confirmationService.confirm({
            target: event.target,
            key: 'basic',
            message: 'Voulez-vous vraiment l\'entretien préventif sélectionné ?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {

                this.bonTravailService.AnnulerEntretienPreventifComplete(etape.etapeBonTravailId).then(res => {
                    if (res.estUnSucces) {
                        etape.indComplete = false;
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Étape annulée.' });
                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                });

            }
        });
    }

    // ajouterNoteEtape(etapeBonTravail: EtapeBonTravailEntite) {
    //     const ref = this.dialogService.open(SaisieNoteMecaniqueComponent, {
    //         data: {
    //             note: etapeBonTravail.note
    //         },
    //         header: 'Ajouter une note',
    //         width: '80%'
    //     }).onClose.subscribe((res: ParametresSaisieNoteMecanique) => {
    //         if (res) {

    //             this.Bloquer();

    //             const ancienneNote = etapeBonTravail.note;
    //             const anciennIndNotePersistante = etapeBonTravail.indNotePersistante;
    //             etapeBonTravail.note = res.note;
    //             etapeBonTravail.note = res.note;
    //             this.bonTravailService.Modifier(etapeBonTravail).then(resModif => {

    //                 this.Debloquer();

    //                 if (resModif.estUnSucces) {

    //                     this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Le note a été modifiée.' });

    //                 } else {
    //                     etapeBonTravail.note = ancienneNote;
    //                     etapeBonTravail.indNotePersistante = anciennIndNotePersistante;
    //                     resModif.messages.forEach(x => {
    //                         this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
    //                     });
    //                 }
    //             });
    //         }
    //     });
    // }


    estFenetreAjoutEtapeActive: boolean = false;

    surAjoutEtape() {
        this.estFenetreAjoutEtapeActive = true;

        const ref = this.dialogService.open(SelectionEtapesComponent, {
            data: {
                bonTravailId: this.bonTravail().bonTravailId,
                itemId: this.bonTravail().item.itemId,
                modeSoumission: this.bonTravail().indSoumission,
                entretienPreventifIds: this.bonTravail().etapes.filter(x => x.entretienPreventif).map(x => x.entretienPreventif.entretienPreventifId),
                entretienCorrectifIds: this.bonTravail().etapes.filter(x => x.entretienCorrectif).map(x => x.entretienCorrectif.entretienCorrectifId)
            },
            header: 'Ajouter des étapes',
            width: '95%'
        }).onClose.subscribe((res: ResultatSelectionEtapes) => {
            this.estFenetreAjoutEtapeActive = false;
            if (!res) {
                return;
            }

            const requete = construireRequeteAjouterEtapes(this.bonTravail().bonTravailId, res);

            const idsEtapesAvantAjout = new Set(
                (this.bonTravail().etapes ?? []).map(e => e.etapeBonTravailId).filter(id => !!id)
            );

            this.marquerMutationLocaleBonTravail(2);
            this.Bloquer();
            this.bonTravailService.AjouterEtapes(requete).then(r => {
                this.Debloquer();
                if (r?.estUnSucces) {
                    this.bonTravail.update(bt => ({
                        ...bt,
                        etapes: fusionnerEtapesAjoutees(bt?.etapes, etapesCreeesDepuisReponse(r.valeur))
                    }));
                    this.initialiserBonTravail();
                    this.rechargerDetail(() => this.ciblerEtapesApresAjout(idsEtapesAvantAjout));
                    this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Étape(s) ajoutée(s).' });
                } else {
                    (r?.messages || []).forEach(x => {
                        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                    });
                    this.rechargerDetail();
                }
            }).catch(() => this.Debloquer());
        });

    }

    ajouterDocument() {

        this.contexteService.Vider();
        this.contexteService.Ajouter("bonTravailId", this.bonTravail().bonTravailId.toString());
        this.contexteService.Ajouter("numero", this.bonTravail().numero.toString());

        this.routerService.navigateByUrl('document/nouveau');
    }

    afficherImage(doc: DocumentEntite) {
        window.open(`${environment.apiDocumentUrl}vbt/${doc.cheminFichier}/${doc.nomFichier}`, "_blank");
    }

    telechargerDocument(doc: DocumentEntite) {
        window.open(`${environment.apiDocumentUrl}tbt/${doc.cheminFichier}/${doc.nomFichier}`, "_blank");
    }

    supprimerDocument(doc: DocumentEntite) {
        this.appMain.confirmationService.confirm({
            target: event.target,
            key: 'basic',
            message: 'Voulez-vous vraiment supprimer le document sélectionné ?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.documentService.SupprimerDocument(doc.documentId).then(res => {
                    if (res.estUnSucces) {
                        this.documents = this.documents.filter(val => val.documentId != doc.documentId);
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Document supprimé.' });
                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                });

            }
        });
    }

    surChangementSelection() {
        this.initialiserMenu();
    }

    consulterHistoriqueEntretienPreventif(item: ItemMin, entretien: EntretienPreventifEntite) {
        const ref = this.dialogService.open(HistoriqueEntretienComponent, {
            data: {
                itemId: item.itemId,
                entretienPreventifId: entretien.entretienPreventifId
            },
            header: `Historique d'entretien - ${item.numero} - ${item.description} - ${entretien.description}`,
            width: '75%'
        }).onClose.subscribe(() => {


        });
    }

    modifierEntretienCorrectif(etape: EtapeBonTravailEntite, entretien: EntretienCorrectifEntite) {

        const ref = this.dialogService.open(DetailEntretienCorrectifComponent, {
            data: {
                entretienCorrectif: entretien
            },
            header: `Modifier un entretien correctif`,
            width: '75%'
        }).onClose.subscribe((res: EntretienCorrectifEntite) => {

            if (res) {
                Object.assign(entretien, res);
                if (entretien.categorie) {
                    entretien.categorie = this.categoriesEntretien.find(y => y.categorieEntretienId == entretien.categorie.categorieEntretienId) ?? entretien.categorie;
                }
                if (entretien.severite) {
                    entretien.severite = this.severites.find(y => y.severiteId == entretien.severite.severiteId) ?? entretien.severite;
                }
                if (entretien.employe) {
                    entretien.employe = this.tousEmployes.find(y => y.employeId == entretien.employe.employeId) ?? entretien.employe;
                }
                etape.description = res.description;
                etape.categorie = entretien.categorie;
                etape.note = res.note;
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Entretien correctif modifié.' });
            }

        });

    }


    /* --------------  PIÈCES  ---------------- */


    surMenuContextuelPiece(event, pieceBonTravail: PieceBonTravailEntite) {

        this.contenuMenuContextuelPiece = [
            {
                label: 'Voir la pièce', icon: 'pi pi-fw pi-eye',
                visible: this.estAutorise('temp_mec'),
                command: _ => this.routerService.navigateByUrl('item/' + pieceBonTravail.item.itemId)
            },
            {
                label: 'Voir les fournisseurs', icon: 'pi pi-fw pi-user',
                visible: this.estAutorise('temp_mec'),
                command: _ => this.consulterFournisseurs(pieceBonTravail)
            },
            {
                label: 'Voir l\'historique de pose (unité)',
                icon: 'pi pi-fw pi-calendar',
                visible: this.estAutorise('temp_mec'),
                command: () => this.historiquePosePiece(pieceBonTravail, false)
            },
            {
                label: 'Voir l\'historique de pose (complet)',
                icon: 'pi pi-fw pi-calendar',
                visible: this.estAutorise('temp_mec'),
                command: () => this.historiquePosePiece(pieceBonTravail, true)
            },
            { separator: true },
            {
                label: 'Modifier la quantité', icon: 'pi pi-fw pi-pencil',
                visible: this.estAutorise('temp_mec') && !this.modeApercu,
                command: _ => this.modifierQuantite(pieceBonTravail)
            },
            { separator: true, visible: this.estAutorise('temp_mec') },
            {
                label: 'Commander', icon: 'pi pi-fw pi-shopping-cart',
                visible: this.estAutorise('temp_mec'),
                /*  disabled: !itemCommande.item.categorie.estSuivi,
                 command: () => this.commander(itemCommande) */
            },
            {
                label: 'Ajuster l\'inventaire', icon: 'pi pi-fw pi-sliders-h',
                visible: this.estAutorise('temp_mec'),
                disabled: !pieceBonTravail.item.categorie?.estSuivi,
                command: () => this.ajusterInventaire(pieceBonTravail)
            }
        ];


        this.menuContextuelPiece.toggle(event);
    }

    ajouterPiece(event, etape: EtapeBonTravailEntite) {
        this.ajouterPieceEtape(etape);
    }

    /**
     * Opens piece selection and persists immediately under the étape.
     */
    ajouterPieceEtape(etape: EtapeBonTravailEntite) {
        this.dialogService.open(SelectionPieceComponent, {
            data: {
                uniteId: this.bonTravail().item.itemId
            },
            header: 'Sélection d\'une pièce',
            width: '95%'
        }).onClose.subscribe((res: ResultatSelectionItem) => {
            if (!res || !etape.etapeBonTravailId) {
                return;
            }
            this.avecIndicateurSauvegardeChamp(this.bonTravailService.AjouterPiece(etape.etapeBonTravailId, {
                itemId: res.item.itemId,
                quantite: res.quantiteDemande?.toString?.() ?? String(res.quantiteDemande),
                note: res.note
            })).subscribe({
                next: (r) => {
                    if (r?.estUnSucces && r.valeur) {
                        this.appliquerRetourServeur(r.valeur);
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Pièce ajoutée.' });
                    }
                },
                error: () => this.rechargerDetail()
            });
        });
    }

    /**
     * Deletes a pièce immediately.
     */
    supprimerPieceImmediate(piece: PieceBonTravailEntite) {
        if (!piece?.pieceBonTravailId) {
            return;
        }
        this.avecIndicateurSauvegardeChamp(this.bonTravailService.SupprimerPiece(piece.pieceBonTravailId)).subscribe({
            next: (r) => {
                if (r?.estUnSucces && r.valeur) {
                    this.appliquerRetourServeur(r.valeur);
                }
            },
            error: () => this.rechargerDetail()
        });
    }

    modifierNotePiece(event, piece: PieceBonTravailEntite) {
        const ref = this.dialogService.open(SaisieNoteMecaniqueComponent, {
            data: {
                note: piece.note ? piece.note : '',
                afficherAjoutFiche: false,
                indAjouterFiche: false
            },
            header: 'Ajouter une note',
            width: '80%'
        }).onClose.subscribe((res: ParametresSaisieNoteMecanique) => {
            if (res && piece.pieceBonTravailId) {
                this.avecIndicateurSauvegardeChamp(this.bonTravailService.ModifierPiece(piece.pieceBonTravailId, {
                    itemId: piece.item?.itemId,
                    quantite: piece.quantite,
                    note: res.note
                })).subscribe({
                    next: (r) => {
                        if (r?.estUnSucces && r.valeur) {
                            this.appliquerRetourServeur(r.valeur);
                        }
                    }
                });
            }
        });
    }



    /**
     * Deletes selected pièces via the edition API using server ids.
     */
    supprimerPieces(event, pieces: PieceBonTravailEntite[]) {
        const ids = (pieces ?? []).map(p => p.pieceBonTravailId).filter(id => !!id);
        if (!ids.length) {
            this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: 'Impossible de supprimer des pièces non enregistrées.'
            });
            return;
        }
        this.appMain.confirmationService.confirm({
            target: event.target,
            key: 'basic',
            message: pieces.length == 1
                ? 'Voulez-vous vraiment supprimer la pièce sélectionnée ?'
                : 'Voulez-vous vraiment supprimer les pièces sélectionnées ?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.actionGroupeePiecesEnCours = true;
                this.avecIndicateurSauvegardeChamp(
                    forkJoin(ids.map(id => this.bonTravailService.SupprimerPiece(id))),
                    ids.length
                ).pipe(
                    finalize(() => { this.actionGroupeePiecesEnCours = false; })
                ).subscribe({
                    next: (results) => {
                        if (actionGroupeeReussie(results)) {
                            this.appliquerRetourServeur(results[results.length - 1].valeur);
                            this.decocherPiecesApresSucces();
                            this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Pièce(s) supprimée(s).' });
                        } else {
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Erreur',
                                detail: results.find(r => !r?.estUnSucces)?.messages?.[0]?.description || 'Échec de la suppression'
                            });
                            this.rechargerDetail();
                        }
                    },
                    error: () => this.rechargerDetail()
                });
            }
        });
    }

    ajusterInventaire(pieceBonTravail: PieceBonTravailEntite) {

        const ref = this.dialogService.open(AjustementInventaireComponent, {
            data: {
                itemId: pieceBonTravail.item.itemId,
                emplacementId: 10000,
                numero: pieceBonTravail.item.numero,
                description: pieceBonTravail.item.description,
                emplacement: this.sdb.Emplacement(10000),
                quantiteCourante: pieceBonTravail.qteInventaire // TODO : donner la responsabilité au composant d'ajustement d'aller chercher l'info sur l'inventaire courant
            },
            header: 'Ajustement d\'inventaire',
            width: '50%'
        }).onClose.subscribe((res: ResultatAjustementInventaire) => {
            if (res) {
                pieceBonTravail.qteInventaire = res.nouvelleQuantite;
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: `L'inventaire a été ajusté.` });
            }
        });

    }

    historiquePosePiece(piece: PieceBonTravailEntite, complet: boolean) {
        const ref = this.dialogService.open(HistoriquePosePieceComponent, {
            data: {
                pieceId: piece.item.itemId,
                uniteId: complet ? null : this.bonTravail().item.itemId
            },
            header: 'Historique de pose',
            width: '90%'
        });
    }


    consulterFournisseurs(pieceBonTravail: PieceBonTravailEntite) {
        const ref = this.dialogService.open(ConsulterFournisseursComponent, {
            data: {
                itemId: pieceBonTravail.item.itemId,
                afficherSelection: true,
                afficherCommander: false
            },
            header: 'Consulter les fournisseurs',
            width: '50%'
        }).onClose.subscribe((res: PrixFournisseurEntite) => {
            console.log(res);
            if (res) {

            }

        });
    }


    // ajouterNotePiece(pieceBonTravail: PieceBonTravailEntite) {
    //     const ref = this.dialogService.open(SaisieNoteMecaniqueComponent, {
    //         data: {
    //             note: pieceBonTravail.note,
    //             indAjouterFiche: false
    //         },
    //         header: 'Ajouter une note',
    //         width: '80%'
    //     }).onClose.subscribe((res: ParametresSaisieNoteMecanique) => {
    //         if (res) {

    //             //TODO: TEMP
    //             pieceBonTravail.note = res.note;

    //             /* this.Bloquer();

    //             const ancienneNote = pieceBonTravail.note;
    //             const anciennIndNotePersistante = pieceBonTravail.indNotePersistante;
    //             pieceBonTravail.note = res.note;
    //             pieceBonTravail.note = res.note;
    //             this.bonTravailService.ModifierPieceBonTravail(pieceBonTravail).then(resModif => {

    //                 this.Debloquer();

    //                 if (resModif.estUnSucces) {

    //                     this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Le note a été modifiée.' });

    //                 } else {
    //                     etapeBonTravail.note = ancienneNote;
    //                     etapeBonTravail.indNotePersistante = anciennIndNotePersistante;
    //                     resModif.messages.forEach(x => {
    //                         this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
    //                     });
    //                 }
    //             }); */
    //         }
    //     });
    // }

    modifierQuantite(pieceBonTravail: PieceBonTravailEntite) {
        const ref = this.dialogService.open(SaisieQuantiteComponent, {
            data: {
                quantite: pieceBonTravail.quantite,
                min: 1
            },
            header: 'Saisir la quantité',
            width: '50%'
        }).onClose.subscribe((res: number) => {
            if (res) {

                //TODO: TEMP
                pieceBonTravail.quantite = res.toString();

                /* this.bonTravailService.ModifierPieceBonCommande({
                    employe: this.profilService.ProfilCourant(),
                    emplacement: this.emplacement,
                    itemsCommande: [{
                        itemCommandeId: itemCommande.itemCommandeId,
                        quantite: res
                    }]
                }).then(res => {
                    if (res.estUnSucces) {
            
                        res.valeur.itemCommandeModifies.forEach(x => {
                            var itemCommandeAModifier = this.itemsCommande.find(ic => ic.itemCommandeId == x.itemCommandeId);
                            itemCommandeAModifier.quantiteDemande = x.quantiteDemande;
                            itemCommandeAModifier.quantite = x.quantite;
                        });
        
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: `Quantité modifiée` });
        
                        this.initialiserMenu();
        
                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                }).catch(() => {
                    this.routerService.navigateByUrl('error');
                }); */
            }

        });
    }


    envoyer(multiPages: boolean) {
        const ref = this.dialogService.open(SelectionEmployesComponent, {
            data: {
                employesIds: this.bonTravail().mecanicien ? [this.bonTravail().mecanicien.employeId] : []
            },
            header: 'Envoi du bon de travail',
            width: '60%'
        }).onClose.subscribe((res: EmployeEntite[]) => {
            if (res) {

                this.Bloquer();

                var destinataires: string[] = res.map(x => x.courriel);

                this.rapportService.EnvoyerRapportBonTravail(this.bonTravail().bonTravailId, multiPages, this.bonTravail().indSoumission, destinataires).then(res => {

                    this.Debloquer();

                    if (res) {
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Le bon de travail a été envoyée.' });
                    } else {
                        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Une erreur s\'est produite lors de l\'envoi du courriel.' });
                    }
                });
            }
        });
    }


    /*   NOTES    */

    surMenuContextuelNote(event, note: NoteEntite) {
        this.contenuMenuContextuelNote = [
            {
                label: 'Modifier',
                icon: 'pi pi-fw pi-pencil',
                visible: this.estAutorise('item_note_modifier'),
                command: () => this.modifierNoteUnite(note)
            },
            { separator: true },
            {
                label: 'Ajouter en tant qu\'entretien correctif',
                icon: 'pi pi-fw pi-briefcase',
                visible: this.estAutorise('entretien_correctif_creer') || this.estAutorise('temp_mec'),
                disabled: !this.modeModification(),
                command: () => this.creerEntretienCorrectifDepuisNote(note)
            },
            { separator: true },
            {
                label: 'Supprimer',
                icon: 'pi pi-fw pi-trash',
                visible: this.estAutorise('item_note_supprimer'),
                command: () => this.supprimerNote(note)
            },
        ];

        this.menuContextuelNote.toggle(event);
    }

    /** Reloads notes shown in the « Notes de l'unité » tab. */
    rechargerNotesUnite(): void {
        const itemId = this.bonTravail()?.item?.itemId;
        if (!itemId) {
            return;
        }
        this.ItemsService.ObtenirNotesItem(itemId).then(notesRes => {
            this.notes = notesRes.valeur ?? [];
        });
    }

    ajouterNoteUnite() {
        const ref = this.dialogService.open(SaisieNoteComponent, {
            data: {
            },
            header: 'Ajouter une note',
            width: '80%'
        }).onClose.subscribe((res: string) => {
            if (res) {

                this.Bloquer();

                this.noteService.Ajouter({
                    date: new Date(),
                    description: res,
                    employe: this.profilService.ProfilCourant(),
                    item: {
                        itemId: this.bonTravail().item.itemId
                    }
                }).then(resAjoutNote => {

                    this.Debloquer();

                    if (resAjoutNote.estUnSucces) {

                        this.rechargerNotesUnite();

                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Le note a été ajoutée.' });

                    } else {
                        resAjoutNote.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                })
            }
        });
    }

    modifierNoteUnite(note: NoteEntite) {
        const ref = this.dialogService.open(SaisieNoteComponent, {
            data: {
                note: note.description
            },
            header: 'Modifier une note',
            width: '80%'
        }).onClose.subscribe((res: string) => {
            if (res) {

                this.Bloquer();

                const ancienneNote = note.description;
                note.description = res
                this.noteService.Modifier(note).then(resModifNote => {

                    this.Debloquer();

                    if (resModifNote.estUnSucces) {

                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Le note a été modifiée.' });

                    } else {
                        note.description = ancienneNote;
                        resModifNote.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                })
            }
        });
    }


    supprimerNote(note: NoteEntite) {
        this.appMain.confirmationService.confirm({
            key: 'basic',
            message: `Voulez-vous vraiment supprimer le note sélectionnée ?`,
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.noteService.Supprimer(note.noteId).then(res => {
                    if (res.estUnSucces) {
                        this.notes = this.notes.filter(val => val.noteId !== note.noteId);
                        //this.nbEntreesNotes--;
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Note supprimée' });
                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                });
            }
        });
    }

    /**
     * Creates an entretien correctif from a unit note and persists it as a BT étape immediately.
     */
    creerEntretienCorrectifDepuisNote(note: NoteEntite) {
        const ref = this.dialogService.open(DetailEntretienCorrectifComponent, {
            data: {
                entretienCorrectif: {
                    entretienCorrectifId: 0,
                    item: {
                        itemId: this.bonTravail().item.itemId
                    },
                    description: note.description,
                    employe: this.profilService.ProfilCourant()
                }
            },
            header: `Ajouter un entretien correctif`,
            width: '75%'
        }).onClose.subscribe((res: EntretienCorrectifEntite) => {
            if (!res) {
                return;
            }

            const idsAvant = new Set(
                (this.bonTravail().etapes ?? []).map(e => e.etapeBonTravailId).filter(id => !!id)
            );
            const requete = construireRequeteAjouterEtapes(this.bonTravail().bonTravailId, {
                etapesCorrectif: [{
                    etapeBonTravailId: 0,
                    entretienCorrectif: res,
                    categorie: res.categorie,
                    description: res.description,
                    note: res.note,
                    indAFaire: true,
                    indComplete: false,
                    typeEtapeBonTravail: this.sdb.TypeEtapeBonTravail(ETypeEtapeBonTravail.EntretienCorrectif)
                }]
            });

            this.marquerMutationLocaleBonTravail(2);
            this.Bloquer();
            this.bonTravailService.AjouterEtapes(requete).then(r => {
                this.Debloquer();
                if (r?.estUnSucces) {
                    this.rechargerDetail(() => this.ciblerEtapesApresAjout(idsAvant));
                    this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Entretien correctif ajouté au bon de travail.' });
                } else {
                    (r?.messages || []).forEach(x => {
                        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                    });
                }
            }).catch(() => this.Debloquer());
        });
    }

    /**
     * Unchecks every travail row after a bulk action fully succeeded.
     * Repeated on the next turn because replacing étape instances recreates OnPush checkboxes.
     */
    private decocherEtapesApresSucces(): void {
        this.decocherSelectionApresSucces('etapes');
    }

    /**
     * Unchecks every pièce row after a bulk delete fully succeeded.
     */
    private decocherPiecesApresSucces(): void {
        this.decocherSelectionApresSucces('pieces');
    }

    /**
     * Clears the PrimeNG selection model and dataKey keys, then again after the table redraws.
     */
    private decocherSelectionApresSucces(cible: 'etapes' | 'pieces'): void {
        const appliquer = () => {
            if (this.vueDetruite) {
                return;
            }
            if (cible === 'etapes') {
                this.selectionMultipleEtapes = decocherSelectionTable(this.dtTravail);
            } else {
                this.selectionMultiplePieces = decocherSelectionTable(this.dtPieces);
            }
        };
        appliquer();
        setTimeout(appliquer, 0);
    }

    /** Whether a given travail bulk-action button should show loading. */
    actionGroupeeEtapeEnChargement(cle: 'marquerFait' | 'marquerNonFait' | 'mecanicien' | 'supprimer' | 'convertir'): boolean {
        return this.actionGroupeeEtapesEnCours === cle;
    }

    /** Disables other travail bulk buttons while one action is in progress. */
    etapesActionGroupeeDesactivee(cle: 'marquerFait' | 'marquerNonFait' | 'mecanicien' | 'supprimer' | 'convertir'): boolean {
        return this.actionGroupeeEtapesEnCours != null && this.actionGroupeeEtapesEnCours !== cle;
    }

    /** Returns selected étapes that are persisted on the server. */
    private obtenirEtapesSelectionEnregistrees(): EtapeBonTravailEntite[] {
        return (this.selectionMultipleEtapes ?? []).filter(e => !!e.etapeBonTravailId);
    }

    /** Marks all selected étapes as complete or incomplete. */
    marquerEtapesSelectionCompletees(indComplete: boolean): void {
        const etapes = this.obtenirEtapesSelectionEnregistrees();
        if (!etapes.length) {
            this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: 'Impossible de modifier des étapes non enregistrées.'
            });
            return;
        }
        this.appliquerChampEtapesEnLot(
            etapes,
            'indComplete',
            indComplete,
            indComplete ? 'Étape(s) marquée(s) comme faites.' : 'Étape(s) marquée(s) comme non faites.',
            indComplete ? 'marquerFait' : 'marquerNonFait'
        );
    }

    /** Opens employee picker and assigns the chosen mécanicien to selected étapes. */
    assignerMecanicienEtapesSelectionnees(): void {
        const etapes = this.obtenirEtapesSelectionEnregistrees();
        if (!etapes.length) {
            this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: 'Impossible de modifier des étapes non enregistrées.'
            });
            return;
        }
        this.dialogService.open(SelectionEmployeComponent, {
            header: 'Assigner un mécanicien',
            width: '32rem',
            data: { mecaniciensSeulement: true }
        }).onClose.subscribe((employe: EmployeEntite | null) => {
            if (!employe) {
                return;
            }
            this.appliquerChampEtapesEnLot(
                etapes,
                'mecanicien',
                employe,
                `Mécanicien assigné à ${etapes.length} étape(s).`,
                'mecanicien'
            );
        });
    }

    /** Persists the same field value on multiple étapes via the edition API. */
    private appliquerChampEtapesEnLot(
        etapes: EtapeBonTravailEntite[],
        champ: string,
        valeur: unknown,
        messageSucces: string,
        cleAction: 'marquerFait' | 'marquerNonFait' | 'mecanicien' | null = null
    ): void {
        if (!this.peutModifierContenu) {
            return;
        }
        if (cleAction) {
            this.actionGroupeeEtapesEnCours = cleAction;
        }
        const champLower = champ.toLowerCase();
        etapes.forEach(e => {
            if (champLower === 'indcomplete') {
                e.indComplete = valeur as boolean;
            } else if (champLower === 'mecanicien' || champLower === 'mecanicienid') {
                e.mecanicien = valeur as EmployeEntite;
                marquerEtapeFaiteSiMecanicienChoisi(e, valeur);
            }
            this.lastOwnFieldPaths.add(`etape.${e.etapeBonTravailId}.${champLower}`);
        });
        this.avecIndicateurSauvegardeChamp(
            forkJoin(etapes.map(e => this.bonTravailService.ModifierEtapeChamp(e.etapeBonTravailId, champ, valeur))),
            etapes.length
        ).pipe(
            finalize(() => {
                if (cleAction) {
                    this.actionGroupeeEtapesEnCours = null;
                }
            })
        ).subscribe({
            next: (results) => {
                if (actionGroupeeReussie(results)) {
                    this.appliquerRetourServeur(results[results.length - 1].valeur);
                    this.decocherEtapesApresSucces();
                    this.messageService.add({ severity: 'success', summary: 'Succès', detail: messageSucces });
                } else {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erreur',
                        detail: results.find(r => !r?.estUnSucces)?.messages?.[0]?.description || 'Échec de la sauvegarde'
                    });
                    this.rechargerDetail();
                }
            },
            error: () => this.rechargerDetail()
        });
    }

    copierMecanicien(etape: EtapeBonTravailEntite) {
        if (!etape.mecanicien) {
            return;
        }
        const employeId = etape.mecanicien.employeId;
        const employe = this.employes.find(x => x.employeId == employeId);
        const cibles = this.selectionMultipleEtapes?.length
            ? this.obtenirEtapesSelectionEnregistrees()
            : this.bonTravail().etapes.filter(e => !!e.etapeBonTravailId);
        if (!cibles.length) {
            return;
        }
        this.appliquerChampEtapesEnLot(
            cibles,
            'mecanicien',
            employe,
            `Mécanicien copié sur ${cibles.length} étape(s).`,
            this.selectionMultipleEtapes?.length ? 'mecanicien' : null
        );
    }

    obtenirTypeBonTravail() {
        return this.typesBonTravail.find(x => x.value == this.bonTravail().type).label;
    }

    afficherSidebarPiecesEtape(etape: EtapeBonTravailEntite) {
        this.etapeCourantePourPieces = etape;
        this.afficherSidebarPieces = true;
    }

    fermerSidebarPieces() {
        this.afficherSidebarPieces = false;
        this.etapeCourantePourPieces = null;
    }

    get EStatuts() {
        return EStatuts;
    }

    get ETypeLienDocument() {
        return ETypeLien;
    }
}
